<template>
	<div class="milestones-wrapper campaign-numbered-section" :class="{
		'mobile-configuration-open': this.mobile_configuration_open,
		'is-action-dependency-locked': !this.parent_requirements_met
	}" v-if="this.is_mounted" ref="milestonesRoot">
		<span class="campaign-section-number campaign-section-number--desktop"
			:class="{
				'is-section-number-locked': !this.parent_requirements_met,
				'is-section-number-complete': this.actionConfigurationComplete && !this.hasActionConfigurationErrors,
				'is-section-number-error': this.hasActionConfigurationErrors
			}"
			data-section-number="4" aria-hidden="true">4</span>
		<div class="milestone-action-card">
		<button type="button" class="milestone-mobile-action-summary campaign-numbered-section"
			:class="{
				'has-mobile-error': this.hasActionConfigurationErrors,
				'is-section-locked': !this.parent_requirements_met,
				'is-section-complete': this.actionConfigurationComplete
			}"
			:aria-expanded="this.mobile_configuration_open ? 'true' : 'false'"
			:aria-disabled="!this.parent_requirements_met"
			@click="this.parent_requirements_met && (this.mobile_configuration_open = !this.mobile_configuration_open)">
			<span class="milestone-mobile-action-summary__icon"
				:class="{ 'mobile-accordion-icon--error': this.hasActionConfigurationErrors }">
				<iconify-icon icon="solar:slider-horizontal-linear" width="21"></iconify-icon>
			</span>
			<span class="milestone-mobile-action-summary__copy">
				<strong>Action Rewarding</strong>
				<small>{{ this.parent_requirements_met ? mobileActionSummary : 'Complete campaign type first' }}</small>
			</span>
			<span class="milestone-mobile-action-summary__edit" aria-hidden="true">
				<i class="fa-solid fa-angle-down mobile-accordion-chevron"></i>
			</span>
			<span class="campaign-section-number campaign-section-number--mobile"
				:class="{
					'is-section-number-locked': !this.parent_requirements_met,
					'is-section-number-complete': this.actionConfigurationComplete && !this.hasActionConfigurationErrors,
					'is-section-number-error': this.hasActionConfigurationErrors
				}"
				data-section-number="4" aria-hidden="true">4</span>
		</button>
		<div class="section-title">
			<span class="campaign-section-heading-icon" aria-hidden="true"><iconify-icon icon="solar:slider-horizontal-linear" width="18" height="18"></iconify-icon></span>
			<h1> What action are you rewarding? <span class="required-mark" aria-hidden="true">*</span></h1>
		</div>
		<div class="campaign-dependency-note" role="status" v-if="!this.parent_requirements_met">
			<iconify-icon icon="solar:lock-password-linear" width="16"></iconify-icon>
			<span>Complete the campaign type to configure the rewarded action.</span>
		</div>
		<div class="input-type-container" :inert="!this.parent_requirements_met" :aria-disabled="!this.parent_requirements_met">
			<div class="input-wrapper">
				<label for=""> Action of rewarding <span class="required-mark" aria-hidden="true">*</span></label>
				<select name="action_of_rewarding" v-model="this.reward_type_for"
					:class="{ 'is-invalid': this.action_of_rewarding_error }"
					:aria-invalid="this.action_of_rewarding_error ? 'true' : 'false'"
					@change="onActionOfRewardingChange">
					<option v-for="(opt, index) in rewardFor"
                            :value="opt.value"
                            :key="index"
                            :selected="opt.selected"
						    :disabled="opt.disabled">
                        {{ opt.name }}
					</option>
				</select>
				<small class="form-text text-danger error_input" v-if="this.action_of_rewarding_error">
					{{ this.action_of_rewarding_error }}
				</small>
			</div>
			<div class="input-wrapper n-dsgn-width" v-if="this.showCostPerThousandViews">
				<label for="cost_per_thousand_views"> Cost per 1000 views <span class="required-mark" aria-hidden="true">*</span></label>
				<div class="campaign-currency-field">
					<input
						id="cost_per_thousand_views"
						type="number"
						name="cost_per_x_views"
						class="campaign-currency-field__input"
						:class="{ 'is-invalid': this.cost_per_views_error || (!this.cost_per_views_touched && this.milestone_errors['cost_per_x_views']) }"
						:aria-invalid="this.cost_per_views_error || (!this.cost_per_views_touched && this.milestone_errors['cost_per_x_views']) ? 'true' : 'false'"
						v-model="this.cost_per_x_views"
						@input="this.cost_per_views_touched = true; validateCostPerViewsAgainstMaximum()"
						@blur="this.cost_per_views_touched = true; validateCostPerViewsAgainstMaximum()"
						placeholder="0"
						min="0.1"
						step="0.01"
					>
					<span class="campaign-currency-field__suffix" aria-hidden="true">USD</span>
				</div>
				<input type="hidden" name="milestones[0][target]" value="1000" :id="this.campaign?.milestones?.[0]?.id">
				<input type="hidden" name="milestones[0][qty]" :value="this.cost_per_x_views">
				<input type="hidden" name="milestones[0][reward_type]" value="7">
				<small class="form-text text-danger error_input" v-if="!this.cost_per_views_touched && this.milestone_errors['cost_per_x_views']">
					{{ this.milestone_errors['cost_per_x_views'][0] }}
				</small>
				<small class="form-text text-danger error_input" v-if="this.cost_per_views_error" data-scroll-role="cost-per-views-error">
					{{ this.cost_per_views_error }}
				</small>
			</div>
			<div class="input-wrapper" v-if="this.showViewCountSelection">
				<label> {{ this.countMethodLabel }} </label>
				<div class="view-count-selection">
					<div class="view-count-selection__bar">
						<button
							type="button"
							class="view-count-selection__trigger"
							@click="toggleViewCountDropdown"
						>
							Social Network Selection
							<span class="view-count-selection__chevron" :class="{ 'is-open': this.view_count_dropdown_open }">▾</span>
						</button>
						<div class="view-count-selection__master">
							<button
								v-for="option in this.countMethodOptions"
								:key="option.value"
								type="button"
								class="view-count-selection__segment"
								:class="{ 'is-active': this.view_count_master === option.value }"
								:disabled="!masterOptionEnabled(option.value)"
								:title="option.hint"
								@click="setCountMethodForAll(option.value)"
							>{{ option.label }}</button>
							<input type="hidden" :name="this.countMethodAllFieldName" :value="this.view_count_master">
						</div>
					</div>
					<div class="view-count-selection__dropdown" :class="{ 'is-open': this.view_count_dropdown_open }">
						<div class="view-count-selection__dropdown-inner">
							<p class="view-count-selection__subtitle">Integration Settings</p>
							<div class="view-count-selection__list">
								<div class="view-count-selection__row" v-for="platform in this.viewCountPlatforms" :key="platform.key">
									<div class="view-count-selection__row-left">
										<div class="view-count-selection__icon" :class="`view-count-selection__icon--${platform.key}`">
											<iconify-icon :icon="platform.icon" width="18"></iconify-icon>
										</div>
										<span class="view-count-selection__name">{{ platform.label }}</span>
									</div>
									<div class="view-count-selection__toggle">
										<button
											v-for="option in this.countMethodOptions"
											:key="option.value"
											type="button"
											class="view-count-selection__segment view-count-selection__segment--small"
											:class="{ 'is-active': view_count_methods[platform.key] === option.value }"
											:disabled="!methodEnabledFor(platform.key, option.value)"
											:title="option.hint"
											@click="setCountMethodFor(platform.key, option.value)"
										>{{ option.label }}</button>
										<input
											type="hidden"
											:name="`${this.countMethodFieldName}[${platform.key}]`"
											:value="view_count_methods[platform.key]"
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
				<input v-if="this.showCostPerThousandViews" type="hidden" name="reward_allocation_type" value="2">
				<div class="input-wrapper" v-if="this.reward_type_for && !this.showCostPerThousandViews">
					<label for=""> Allocation type <span class="required-mark" aria-hidden="true">*</span></label>
					<select name="reward_allocation_type" v-model="this.allocation_type">
					<option v-for="at in allocationType" :value="at.value" :selected="at.selected" :disabled="at.disabled">
						{{ at.name }} </option>
				</select>
				<small class="form-text text-danger error_input" v-if="this.allocation_type_error">
					{{ this.allocation_type_error }}
				</small>
			</div>
			<div class="double-input" v-if="!this.showCostPerThousandViews">
				<div class="input-wrapper mt-5" v-if="this.allocation_type">
					<label for="milestones_nr"> Number of milestones <span class="required-mark" aria-hidden="true">*</span></label>
					<select id="milestones_nr" name="milestones_number" v-model="this.milestones_count">
						<option :value="el" v-for="el in milestones_number"> {{ el }} </option>
					</select>
				</div>
				<!-- Budget milestones carry a dollar amount, not a quantity of prizes, so the toggle
					 is only meaningful for pay-as-you-go rewards (the ones with a "Max quantity"). -->
				<div class="input-wrapper mt-5" v-if="this.allocation_type && this.pag_campaign">
					<label for="show_milestones_qty"> Show the milestones quantity </label>
					<select id="show_milestones_qty" name="show_milestones_qty" v-model="this.milestones_qty_state">
						<option value="0"> No </option>
						<option value="1"> Yes </option>
					</select>
				</div>
			</div>
		</div>
		</div>

		<button type="button" class="milestone-mobile-manager"
			:class="{ 'has-mobile-error': this.hasMilestoneConfigurationErrors }"
			v-if="this.parent_requirements_met && this.allocation_type && this.milestones_count && !this.showCostPerThousandViews"
			:aria-expanded="this.mobile_milestones_open ? 'true' : 'false'"
			@click="this.mobile_milestones_open = !this.mobile_milestones_open">
			<span class="milestone-mobile-manager__icon"
				:class="{ 'mobile-accordion-icon--error': this.hasMilestoneConfigurationErrors }"><i class="fa-solid fa-flag"></i></span>
			<span class="milestone-mobile-manager__copy">
				<span><strong>Milestones</strong><b>{{ this.milestones_count }}</b></span>
				<small>Define milestones and rewards for your campaign.</small>
			</span>
			<span class="milestone-mobile-manager__manage">Manage <i class="fa-solid fa-angle-up" :class="{ 'is-closed': !this.mobile_milestones_open }"></i></span>
		</button>

		<div id="milestones_group" v-if="this.parent_requirements_met && this.allocation_type && this.milestones_count && !this.showCostPerThousandViews"
			:class="[budget_campaign ? 'budget-milestones-group' : 'paid-milestones-group', { 'milestones-mobile-closed': !this.mobile_milestones_open }]">
			<div
				class="milestone-el"
				:class="{
					'milestone-el--expanded': !this.pag_campaign || isMilestoneExpanded(index),
					'milestone-el--collapsed': this.pag_campaign && !isMilestoneExpanded(index),
					'milestone-el--error': getMilestoneErrors(index).length > 0
				}"
				v-for="(item, index) in this.milestones_count"
				:key="index"
			>
				<button
					v-if="this.pag_campaign"
					type="button"
					class="milestone-card-toggle"
					:aria-expanded="isMilestoneExpanded(index) ? 'true' : 'false'"
					@click="toggleMilestone(index)"
				>
					<span class="milestone-card-toggle__number">{{ milestoneNumber(index) }}</span>
					<span class="milestone-card-toggle__title">Milestone {{ index + 1 }}</span>
					<span class="milestone-card-toggle__reward" v-if="milestoneRewardTypeName(index)">
						{{ milestoneRewardTypeName(index) }}
					</span>
					<i class="fa-solid fa-angle-down milestone-card-toggle__chevron" aria-hidden="true"></i>
				</button>
				<div v-else class="milestone-card-toggle milestone-card-toggle--paid">
					<span class="milestone-card-toggle__number">{{ milestoneNumber(index) }}</span>
					<span class="milestone-card-toggle__title">Milestone {{ index + 1 }}</span>
					<span class="milestone-card-toggle__reward">Paid reward</span>
				</div>
				<div class="milestone-card-body" v-show="!this.pag_campaign || isMilestoneExpanded(index)">
				<input v-if="this.keep_original_milestones && this.campaign_data?.milestones?.[index]?.id" type="hidden" :value="this.campaign_data.milestones[index].id"
										:name="`milestones[${index}][id]`">
				<div class="row milestone-top-row">
					<div class="top-row-st">
						<div class="top-row-heading-txt">
							<!-- <div
								class="image-box"
								v-if="images[index] && this.reward_type.model[index] != 3 && this.reward_type.model[index] != 6"
								:style="{
									backgroundImage: `url(${images[index].original_url ?? images[index]})`
								}"
							></div> -->

						</div>

						<div
							:class="budget_campaign ? 'top-row-inputs-budget' : 'top-row-inputs'">
							<div class="first-lane">
								<div class="el-qty-inp milestone-field">
									<label class="milestone-field-label" :for="`milestone_${index}_target`">
										{{ milestoneTargetLabel(index) }} <span class="required-mark" aria-hidden="true">*</span>
									</label>
									<input v-model="this.reward_target_value.model[index]" class="milestone-control milestone-control--number"
										:id="`milestone_${index}_target`"
										:class="{ 'milestone-input-error': isTargetInvalid(index) || this.invalid_target_sequence[index] }"
										type="number" :name="`milestones[${index}][target]`"
										min="1" step="1" inputmode="numeric" :data-integer="true"
										@input="sanitizeIntegerInput($event, 'target', index)"
										@blur="checkValue(index, $event)">

									<p v-if="!this.pag_campaign && this.milestone_errors[`milestones.${index}.id`]"
										class="form-text text-danger error_input mlst_error"> {{
											this.milestone_errors[`milestones.${index}.id`][0] }}
									</p>

								</div>
								<div class="el-type-rwd milestone-field" v-if="this.pag_campaign">
									<label class="milestone-field-label" :for="`milestone_${index}_reward_type`">
										Reward type <span class="required-mark" aria-hidden="true">*</span>
									</label>
									<select class="milestone-control milestone-control--select" :name="`milestones[${index}][reward_type]`"
										:id="`milestone_${index}_reward_type`"
										:class="{ 'milestone-input-error': isRewardTypeInvalid(index) }"
										v-model="this.reward_type.model[index]">
										<option v-for="reward_type_option in this.refactorRewardOptions"
											:value="reward_type_option.value" :selected="reward_type_option.selected"
											:disabled="reward_type_option.disabled">
											{{ reward_type_option.name }}
										</option>
									</select>
									<p v-if="this.pag_campaign && this.milestone_errors[`milestones.${index}.reward_type`]"
										class="form-text text-danger error_input mlst_error"> {{
											this.milestone_errors[`milestones.${index}.reward_type`][0] }}
									</p>
								</div>
							</div>
							<div
								class="second-lane"
								:class="{
									'second-lane--standard-reward': this.pag_campaign && (this.reward_type.model[index] == 3 || this.reward_type.model[index] == 6)
								}"
							>
								<!-- milestone-level image upload hidden for now; use per-product uploads instead -->

								<input v-if="this.budget_campaign" type="hidden" value="1"
									:name="`milestones[${index}][reward_type]`">

								<!-- amount allocated -->
								<div class="bdg_camp-ammount milestone-field" v-if="this.budget_campaign">
									<label class="milestone-field-label" :for="`milestone_${index}_amount`">
										Dollar amount <span class="required-mark" aria-hidden="true">*</span>
									</label>
									<div class="budget-amount-control">
										<span class="budget-amount-control__prefix" aria-hidden="true">$</span>
										<input class="milestone-control milestone-control--currency" type="number" v-model="this.qty.model[index]"
										:id="`milestone_${index}_amount`"
										:class="{ 'milestone-input-error': isBudgetQtyInvalid(index) }"
										:name="`milestones[${index}][qty]`"
										min="1"
										max="999999"
										step="0.01"
										placeholder="0.00"
										@blur="this.qty_touched[index] = true">
									</div>
									<p v-if="allocation_type == 1 && maximum_reward_per_video !== null && qty.model[index] && parseFloat(qty.model[index]) > maximum_reward_per_video"
										class="form-text text-danger error_input mlst_error">Cannot exceed ${{ maximum_reward_per_video }}</p>
								</div>

								<!-- if type discount -->
								<div class="discount-wrapper-rwd-type"
									v-if="this.reward_type.model[index] == 2 && this.pag_campaign">
									<div class="discount-products"
										v-if="this.discount_products[index] && this.discount_products[index].length">
										<div class="discount-product-row"
											v-for="(discountProduct, discountIndex) in this.discount_products[index]"
											:key="`dp-row-${index}-${discountIndex}`">
											<div class="discount-product-image-slot milestone-media-upload">
													<div class="discount-product-image" v-if="discountProduct.image || discountProduct.preview_url">
														<img :src="discountProduct.preview_url || discountProduct.image" alt="">
														<button type="button" class="image-clear-btn"
															@click="clearDiscountImage(index, discountIndex)">
															<i class="fa-solid fa-xmark"></i>
														</button>
													</div>
												<div class="file-input">
													<input type="file"
														:name="`milestones[${index}][data][${discountIndex}][image]`"
														:id="`milestones_${index}_discount_${discountIndex}_image`"
														:accept="milestone_image_accept"
														@change="onDiscountImageChange($event, index, discountIndex)">
													<label :for="`milestones_${index}_discount_${discountIndex}_image`" class="btn-2 milestone-upload-label">
														<span>Upload reward image</span>
														<br>
														<span class="milestone-upload-label__meta">Optional · JPG, JPEG or PNG · {{ milestone_image_meta_label }}</span>
													</label>
												</div>
											</div>
											<div class="discount-product-inputs">
													<div class="milestone-field">
														<span class="milestone-field-label">Product <span class="required-mark" aria-hidden="true">*</span></span>
														<div class="milestone-control milestone-control--display">
															<span class="discount-product-name-text">
																{{ discountProduct.name ? discountProduct.name : discountProduct.discount_product_name }}
															</span>
														</div>
													</div>
													<div class="discount-input-wrapper milestone-field">
														<label class="milestone-field-label" :for="`milestone_${index}_discount_${discountIndex}_value`">Discount % <span class="required-mark" aria-hidden="true">*</span></label>
														<input type="number" class="milestone-control milestone-control--number"
															:id="`milestone_${index}_discount_${discountIndex}_value`"
														:class="{ 'milestone-input-error': isDiscountValueInvalid(index, discountIndex) }"
														:name="`milestones[${index}][data][${discountIndex}][discount_value]`"
														v-model="this.discount_values[index][discountIndex]" placeholder="60%"
														@blur="this.discount_values_touched[index][discountIndex] = true"
														min="1" max="100">
												</div>
													<div class="discount-input-wrapper milestone-field">
														<label class="milestone-field-label" :for="`milestone_${index}_discount_${discountIndex}_qty`">Max quantity <span class="required-mark" aria-hidden="true">*</span></label>
														<input class="milestone-control milestone-control--number"
															:id="`milestone_${index}_discount_${discountIndex}_qty`"
														:class="{ 'milestone-input-error': isDiscountQtyInvalid(index, discountIndex) }"
														type="number" v-model="this.discount_qty[index][discountIndex]"
														:name="`milestones[${index}][data][${discountIndex}][qty]`" min="1" step="1" inputmode="numeric" :data-integer="true"
														@input="sanitizeIntegerInput($event, 'discount_qty', index, discountIndex)"
														@blur="this.discount_qty_touched[index][discountIndex] = true"
														placeholder="Max #">
												</div>
											</div>
											<button type="button" class="delete-btn milestone-product-delete"
												aria-label="Remove discount product"
												@click="deleteDiscountProduct(index, discountIndex)">
												<i class="fa-solid fa-trash-can"></i>
												<span>Remove product</span>
											</button>
											<input type="hidden"
												:value="discountProduct.id ? discountProduct.id : discountProduct.discount_product_id"
												:name="`milestones[${index}][data][${discountIndex}][discount_product_id]`">
											<input type="hidden"
												:value="discountProduct.name ? discountProduct.name : discountProduct.discount_product_name"
												:name="`milestones[${index}][data][${discountIndex}][discount_product_name]`">
											<input v-if="discountProduct.image && !discountProduct.preview_url" type="hidden"
												:value="discountProduct.image"
												:name="`milestones[${index}][data][${discountIndex}][image]`">
										</div>
									</div>
									<div class="discount-inline">
										<div class="inline-search inline-search--discount discount-inline__search"
											v-if="this.show_discount_search[index] !== false && !hasReachedMilestoneItemLimit(2, index)">
											<label class="milestone-field-label" :for="`milestone_${index}_discount_search`">Product search <span class="required-mark" aria-hidden="true">*</span></label>
											<div class="inline-search__bar milestone-search-field">
												<span class="inline-search__icon" aria-hidden="true">
													<i class="fa-solid fa-magnifying-glass"></i>
												</span>
												<input class="milestone-control milestone-control--search"
													:id="`milestone_${index}_discount_search`"
													:class="{ 'milestone-input-error': isDiscountSearchInvalid(index) }"
													type="search"
													v-model="this.inline_search_terms[this.inlineSearchKey(2, index)]"
													@keyup="this.dataQuery($event.target.value, 2, index)"
													placeholder="Choose product"
													@focus="openInlineSearch(2, index)">
											</div>
											<div class="results-list inline-search__results"
												v-if="this.inline_search_terms[this.inlineSearchKey(2, index)] && this.inline_search_terms[this.inlineSearchKey(2, index)].length > 3 && this.inline_search_index === index && this.inline_search_type === 2">
												<div class="loading-element inline-search__loading-state" v-if="this.is_typing">
													<div class="inline-search__loader" aria-hidden="true">
														<span></span>
														<span></span>
														<span></span>
													</div>
													<p class="inline-search__loading-text">Searching products...</p>
												</div>
												<div class="list-element" v-for="(product, pIndex) in this.searchedProducts"
													:key="`d-${index}-${pIndex}`">
													<img :src="product.image" alt="">
													<span>{{ product.name }}</span>
													<button type="button" class="fk_btn inline-search__add-btn" @click="selectProduct(product, 2, index)">Add</button>
												</div>
												<div class="inline-search__empty-state" v-if="!this.is_typing && this.inline_search_terms[this.inlineSearchKey(2, index)] && this.inline_search_terms[this.inlineSearchKey(2, index)].length > 3 && !this.searchedProducts.length">
													<p class="inline-search__empty-title">No matching products</p>
													<p class="inline-search__empty-copy">Try a different keyword.</p>
												</div>
											</div>
										</div>
									</div>
									<button class="btn-2 discount-add-btn" type="button"
										v-if="this.show_discount_search[index] === false && !hasReachedMilestoneItemLimit(2, index)"
										@click="this.show_discount_search[index] = true">
										Add another product
									</button>
									<small v-if="hasReachedMilestoneItemLimit(2, index)" class="form-text milestone-limit-note">
										{{ getMilestoneItemLimitMessage() }}
									</small>
								</div>



								<!-- if type giftcard -->
								<div class="giftcard-wrapper-rwd-type"
									v-if="this.reward_type.model[index] == 3 && this.pag_campaign">
									<div class="reward-inline-block">
										<div class="reward-inline-row">
											<div class="reward-image-upload milestone-media-upload">
												<div class="reward-image-preview" v-if="getImagePreviewUrl(index)"
													:style="{ backgroundImage: `url(${getImagePreviewUrl(index)})` }">
													<button type="button" class="image-clear-btn"
														@click="clearMilestoneImage(index, 'gift')">
														<i class="fa-solid fa-xmark"></i>
													</button>
												</div>
												<div class="file-input">
													<input type="file" :name="`milestones[${index}][image]`"
														:id="`milestones_${index}_gift_image`" :accept="milestone_image_accept" @change="onFileChange($event, index)">
												<label :for="`milestones_${index}_gift_image`" class="btn-2 milestone-upload-label">
													<span>Upload reward image</span>
													<br>
													<span class="milestone-upload-label__meta">Optional · JPG, JPEG or PNG · {{ milestone_image_meta_label }}</span>
													</label>
												</div>
											</div>
											<div class="giftcard-input-wrapper milestone-field">
												<label class="milestone-field-label" :for="`milestone_${index}_gift_value`">Gift card value <span class="required-mark" aria-hidden="true">*</span></label>
												<input class="milestone-control milestone-control--currency" type="number"
													:id="`milestone_${index}_gift_value`"
													:class="{ 'milestone-input-error': isGiftValueInvalid(index) }"
													:name="`milestones[${index}][data][gift_card_value]`" placeholder="$0.00"
													v-model="this.gift_discount.model[index]" min="1"
													@blur="this.gift_value_touched[index] = true">
											</div>
										</div>
									</div>
								</div>



								<!-- if type merchandise -->
								<div class="merchandise-wrapper-rwd-type"
									v-if="this.reward_type.model[index] == 4 && this.pag_campaign">
										<div class="merch-products"
											v-if="this.merchandise_products[index] && this.merchandise_products[index].length">
											<div class="merch-product-row"
												v-for="(merch, merch_index) in this.merchandise_products[index]"
												:key="`mp-${merch_index}-${index}`">
											<div class="merch-product-image-slot milestone-media-upload">
														<div class="merch-product-image" v-if="merch.image || merch.preview_url">
															<img :src="merch.preview_url || merch.image" alt="">
															<button type="button" class="image-clear-btn"
																@click="clearMerchImage(index, merch_index)">
																<i class="fa-solid fa-xmark"></i>
															</button>
														</div>
														<div class="file-input">
															<input type="file"
																:name="`milestones[${index}][data][products][${merch_index}][image]`"
																:id="`milestones_${index}_merch_${merch_index}_image`"
																:accept="milestone_image_accept"
																@change="onMerchandiseImageChange($event, index, merch_index)">
													<label :for="`milestones_${index}_merch_${merch_index}_image`" class="btn-2 milestone-upload-label">
														<span>Upload reward image</span>
														<br>
														<span class="milestone-upload-label__meta">Optional · JPG, JPEG or PNG · {{ milestone_image_meta_label }}</span>
															</label>
														</div>
											</div>
											<div class="merch-product-inputs">
												<div class="milestone-field">
													<span class="milestone-field-label">Product <span class="required-mark" aria-hidden="true">*</span></span>
													<div class="milestone-control milestone-control--display">
														<span class="merch-product-name-text"> {{ merch.name }} </span>
													</div>
												</div>
												<div class="merch-input-wrapper milestone-field">
													<label class="milestone-field-label" :for="`milestone_${index}_merch_${merch_index}_qty`">Max quantity <span class="required-mark" aria-hidden="true">*</span></label>
													<input class="milestone-control milestone-control--number"
														:id="`milestone_${index}_merch_${merch_index}_qty`"
															:class="{ 'milestone-input-error': isMerchQtyInvalid(index, merch_index) }"
															type="number" v-model="this.merchandise_qty[index][merch_index]"
															:name="`milestones[${index}][data][products][${merch_index}][qty]`" min="1" step="1" inputmode="numeric" :data-integer="true"
															@input="sanitizeIntegerInput($event, 'merch_qty', index, merch_index)"
															@blur="this.merchandise_qty_touched[index][merch_index] = true"
															placeholder="Max #">
													</div>
												</div>
												<button type="button" class="delete-btn milestone-product-delete"
													aria-label="Remove merchandise product"
													@click="deleteItem(merch, index, merch_index)">
													<i class="fa-solid fa-trash-can"></i>
													<span>Remove product</span>
												</button>

												<input type="hidden" :value="merch.id"
													:name="`milestones[${index}][data][products][${merch_index}][id]`">
												<input type="hidden" :value="merch.name"
													:name="`milestones[${index}][data][products][${merch_index}][name]`">
												<input v-if="merch.image && !merch.preview_url" type="hidden"
													:value="merch.image"
													:name="`milestones[${index}][data][products][${merch_index}][image]`">
											</div>
										</div>
										<div class="inline-search inline-search--merch"
											v-if="this.show_merch_search[index] !== false && !hasReachedMilestoneItemLimit(4, index)">
										<label class="milestone-field-label" :for="`milestone_${index}_merch_search`">Product search <span class="required-mark" aria-hidden="true">*</span></label>
										<div class="inline-search__bar milestone-search-field merchandise-input-wrapper">
												<span class="inline-search__icon" aria-hidden="true">
													<i class="fa-solid fa-magnifying-glass"></i>
												</span>
											<input class="milestone-control milestone-control--search"
												:id="`milestone_${index}_merch_search`"
													:class="{ 'milestone-input-error': isMerchSearchInvalid(index) }"
													type="search"
													v-model="this.inline_search_terms[this.inlineSearchKey(4, index)]"
													@keyup="this.dataQuery($event.target.value, 4, index)"
													placeholder="Search product"
													@focus="openInlineSearch(4, index)">
											</div>
											<div class="results-list inline-search__results"
												v-if="this.inline_search_terms[this.inlineSearchKey(4, index)] && this.inline_search_terms[this.inlineSearchKey(4, index)].length > 3 && this.inline_search_index === index && this.inline_search_type === 4">
												<div class="loading-element inline-search__loading-state" v-if="this.is_typing">
													<div class="inline-search__loader" aria-hidden="true">
														<span></span>
														<span></span>
														<span></span>
													</div>
													<p class="inline-search__loading-text">Searching products...</p>
												</div>
												<div class="list-element" v-for="(product, pIndex) in this.searchedProducts"
													:key="`m-${index}-${pIndex}`">
													<img :src="product.image" alt="">
													<span>{{ product.name }}</span>
													<button type="button" class="fk_btn inline-search__add-btn" @click="selectProduct(product, 4, index)">Add</button>
												</div>
												<div class="inline-search__empty-state" v-if="!this.is_typing && this.inline_search_terms[this.inlineSearchKey(4, index)] && this.inline_search_terms[this.inlineSearchKey(4, index)].length > 3 && !this.searchedProducts.length">
													<p class="inline-search__empty-title">No matching products</p>
													<p class="inline-search__empty-copy">Try a different keyword.</p>
												</div>
											</div>
											</div>
											<button class="btn-2 merch-add-btn" type="button"
												v-if="this.show_merch_search[index] === false && !hasReachedMilestoneItemLimit(4, index)"
												@click="this.show_merch_search[index] = true">
												Add another product
											</button>
											<small v-if="hasReachedMilestoneItemLimit(4, index)" class="form-text milestone-limit-note">
												{{ getMilestoneItemLimitMessage() }}
											</small>
											<p v-if="this.milestone_errors[`milestones.${index}.data.products`]"
												class="form-text text-danger error_input mlst_error"> {{
													this.milestone_errors[`milestones.${index}.data.products`][0] }}
										</p>
								</div>



								<!-- if type cash -->
								<div class="cash-wrapper-rwd-type"
									v-if="this.reward_type.model[index] == 6 && this.pag_campaign">
									<div class="reward-inline-block">
										<div class="reward-inline-row">
											<div class="reward-image-upload milestone-media-upload">
												<div class="reward-image-preview" v-if="getImagePreviewUrl(index)"
													:style="{ backgroundImage: `url(${getImagePreviewUrl(index)})` }">
													<button type="button" class="image-clear-btn"
														@click="clearMilestoneImage(index, 'cash')">
														<i class="fa-solid fa-xmark"></i>
													</button>
												</div>
												<div class="file-input">
													<input type="file" :name="`milestones[${index}][image]`"
														:id="`milestones_${index}_cash_image`" :accept="milestone_image_accept" @change="onFileChange($event, index)">
												<label :for="`milestones_${index}_cash_image`" class="btn-2 milestone-upload-label">
													<span>Upload reward image</span>
													<br>
													<span class="milestone-upload-label__meta">Optional · JPG, JPEG or PNG · {{ milestone_image_meta_label }}</span>
													</label>
												</div>
											</div>
											<div class="cash-input-wrapper milestone-field">
												<label class="milestone-field-label" :for="`milestone_${index}_cash_value`">Cash value <span class="required-mark" aria-hidden="true">*</span></label>
												<input class="milestone-control milestone-control--currency" type="number" :name="`milestones[${index}][data][cash_value]`"
													:id="`milestone_${index}_cash_value`"
													:class="{ 'milestone-input-error': isCashValueInvalid(index) }"
													placeholder="$0.00" v-model="this.cash_value.model[index]" min="1"
													@blur="this.cash_value_touched[index] = true">
											</div>
										</div>
									</div>
								</div>

								<!-- if type custom -->
								<div class="custom-wrapper-rwd-type"
									v-if="this.reward_type.model[index] == 5 && this.pag_campaign">
									<div class="custom-products"
										v-if="this.custom_products[index] && this.custom_products[index].length">
										<div class="custom-product-row"
											v-for="(customItem, customIndex) in this.custom_products[index]"
											:key="`custom-${index}-${customIndex}`">
										<div class="custom-product-image-slot milestone-media-upload">
												<div class="custom-product-image" v-if="customItem.preview_url || customItem.image"
													:style="{ backgroundImage: `url(${customItem.preview_url || customItem.image})` }">
													<button type="button" class="image-clear-btn"
														@click="clearCustomImage(index, customIndex)">
														<i class="fa-solid fa-xmark"></i>
													</button>
												</div>
													<div class="file-input">
														<input type="file"
															:name="`milestones[${index}][data][${customIndex}][image]`"
															:id="`milestones_${index}_custom_${customIndex}_image`"
															:accept="milestone_image_accept"
															@change="onCustomImageChange($event, index, customIndex)">
												<label :for="`milestones_${index}_custom_${customIndex}_image`" class="btn-2 milestone-upload-label">
													<span>Upload reward image</span>
													<br>
													<span class="milestone-upload-label__meta">Optional · JPG, JPEG or PNG · {{ milestone_image_meta_label }}</span>
														</label>
													</div>
										</div>
										<div class="custom-product-inputs">
											<div class="milestone-field">
												<label class="milestone-field-label" :for="`milestone_${index}_custom_${customIndex}_name`">Reward name <span class="required-mark" aria-hidden="true">*</span></label>
													<input class="milestone-control"
														:id="`milestone_${index}_custom_${customIndex}_name`"
														:class="{ 'milestone-input-error': isCustomNameInvalid(index, customIndex) }"
														type="text"
														v-model="customItem.name"
														:name="`milestones[${index}][data][${customIndex}][name]`"
														@blur="this.custom_name_touched[index][customIndex] = true"
														placeholder="Name">
											</div>
											<div class="custom-input-wrapper milestone-field">
												<label class="milestone-field-label" :for="`milestone_${index}_custom_${customIndex}_qty`">Max quantity <span class="required-mark" aria-hidden="true">*</span></label>
												<input class="milestone-control milestone-control--number"
													:id="`milestone_${index}_custom_${customIndex}_qty`"
														:class="{ 'milestone-input-error': isCustomQtyInvalid(index, customIndex) }"
														type="number" v-model="customItem.qty"
														:name="`milestones[${index}][data][${customIndex}][qty]`" min="1" step="1" inputmode="numeric" :data-integer="true"
														@input="sanitizeIntegerInput($event, 'custom_qty', index, customIndex)"
														@blur="this.custom_qty_touched[index][customIndex] = true"
														placeholder="Max #">
											</div>
										</div>
										<button type="button" class="delete-btn milestone-product-delete"
											aria-label="Remove custom reward"
											@click="deleteCustomProduct(index, customIndex)">
											<i class="fa-solid fa-trash-can"></i>
											<span>Remove reward</span>
										</button>
											<input v-if="customItem.image && !customItem.preview_url" type="hidden"
												:value="customItem.image"
												:name="`milestones[${index}][data][${customIndex}][image]`">
										</div>
									</div>
										<button class="btn-2 custom-add-btn" type="button"
											v-if="!hasReachedMilestoneItemLimit(5, index)"
											@click="addCustomProduct(index)">
											{{ this.custom_products[index] && this.custom_products[index].length ? 'Add another product' : 'Add product' }}
										</button>
										<small v-if="hasReachedMilestoneItemLimit(5, index)" class="form-text milestone-limit-note">
											{{ getMilestoneItemLimitMessage() }}
										</small>
									</div>

								<div class="el-max-qty milestone-field"
									v-if="this.pag_campaign && this.reward_type.model[index] && this.reward_type.model[index] != 2 && this.reward_type.model[index] != 4 && this.reward_type.model[index] != 5">
									<label class="milestone-field-label" :for="`milestone_${index}_max_qty`">Max quantity <span class="required-mark" aria-hidden="true">*</span></label>
									<input class="milestone-control milestone-control--number" type="number" v-model="this.qty.model[index]"
										:id="`milestone_${index}_max_qty`"
										:class="{ 'milestone-input-error': isStandardQtyInvalid(index) }"
										:name="`milestones[${index}][qty]`" min="1" step="1" inputmode="numeric" :data-integer="true"
										@input="sanitizeIntegerInput($event, 'qty', index)"
										@blur="this.qty_touched[index] = true"
										placeholder="Max #">
								</div>
							</div>
						</div>
					</div>
					<div class="milestone-errors-row" v-if="hasMilestoneErrors(index)">
						<p v-for="(error, errIndex) in getMilestoneErrors(index)" :key="`mlst-${index}-err-${errIndex}`"
							class="form-text text-danger mlst-error-line">
							{{ error }}
						</p>
					</div>
					<div class="milestone-errors-row" v-if="hasMilestoneImageErrors(index)">
						<p v-for="(error, errIndex) in getMilestoneImageErrors(index)" :key="`mlst-${index}-img-err-${errIndex}`"
							class="form-text text-danger mlst-error-line">
							{{ error }}
						</p>
					</div>
					<div class="col-xl-4 col-lg-6 col-md-6 col-12" v-if="!this.pag_campaign && this.milestone_errors[`milestones.${index}.target`]">
						<div class="inner-col">
							<div class="inner-col-content">
								<p v-if="this.milestone_errors[`milestones.${index}.target`]"
									class="form-text text-danger error_input mlst_error"> {{
										this.milestone_errors[`milestones.${index}.target`][0] }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>
		<p v-if="show_milestone_errors && isCumulativeSumInvalid()" class="form-text text-danger error_input" data-scroll-role="milestone-summary-error" style="margin-top: 8px;">
			The sum of all milestone rewards must equal the maximum reward per influencer (${{ maximum_reward_per_video }}).
		</p>
		<p v-if="show_milestone_errors && isPerMilestoneLastInvalid()" class="form-text text-danger error_input" data-scroll-role="milestone-summary-error" style="margin-top: 8px;">
			The last milestone must equal the maximum reward per influencer (${{ maximum_reward_per_video }}).
		</p>

		<div id="notificationToast" :class="['toast', 'align-items-center', { 'toast--success': this.notification_type === 'success', 'toast--danger': this.notification_type === 'delete' }]" role="alert" aria-live="assertive" aria-atomic="true"
			data-bs-autohide="true" data-bs-delay="1000">
			<div class="d-flex">
				<div class="toast-body">
					{{ this.notification_message }}
				</div>
				<button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: "MilestonesConfiguration",
	props: [
		'campaign',
		'errors',
		'old_values',
		'show_shop_products',
		'available_socials',
		'selected_socials',
		'platform_api_settings',
		'platform_auto_settings',
		'platform_method_availability',
		'saved_view_count_methods',
		'saved_like_count_methods',
		'max_products',
		'image_upload_max'
	],

	data() {
		// Frontend limits and upload copy come from backend config passed through Blade.
		const parsedMaxProducts = parseInt(this.max_products, 10)
		const normalizedMaxProducts = Number.isFinite(parsedMaxProducts) && parsedMaxProducts > 0 ? parsedMaxProducts : 5
		const parsedMilestoneImageMax = parseInt(this.image_upload_max?.milestone, 10)
		const milestoneImageMaxDimension = Number.isFinite(parsedMilestoneImageMax) && parsedMilestoneImageMax > 0
			? parsedMilestoneImageMax
			: null
		const milestoneImageMetaLabel = milestoneImageMaxDimension
			? `${milestoneImageMaxDimension}x${milestoneImageMaxDimension}px max`
			: ''
		const milestoneImageHelpText = `Allowed image types: JPG, JPEG, PNG.${milestoneImageMaxDimension ? ` Max dimensions: ${milestoneImageMaxDimension}x${milestoneImageMaxDimension}px.` : ''}`

		return {
			inline_search_index: null,
			inline_search_type: null,
			// Search text is stored per reward type + milestone, while fetched results are shared.
			inline_search_terms: {},
			milestones_qty_state: 0,
			is_typing: false,
			images: [],
			milestone_errors: this.errors,
			campaign_data: this.campaign,
			available_socials_data: this.available_socials,
			selected_socials_data: this.selected_socials,
			selected_socials_live: [],
			set_values: this.old_values,
			can_add_products: this.show_shop_products,
			reward_target_value: {
				model: [],
			},
			target_touched: [],
			qty_touched: [],
			notification_message: '',
			pag_campaign: false,
			budget_campaign: true,
			is_mounted: false,
			notifications_toast: null,
			notification_type: null,
			milestone_image_accept: '.jpg,.jpeg,.png',
			milestone_image_meta_label: milestoneImageMetaLabel,
			milestone_image_help_text: milestoneImageHelpText,
			milestones_count: 1,
			reward_type_for: null,
			original_action_of_rewarding: null,
			keep_original_milestones: true,
			restore_used: null,
			allocation_type: null,
			milestones_number: [1, 2, 3, 4, 5],
			cost_per_x_views: this.campaign?.cost_per_x_views ?? '',
			cost_per_views_error: '',
			cost_per_views_touched: false,
			action_of_rewarding_error: '',
			allocation_type_error: '',
			maximum_reward_per_video: null,
			milestone_reward_error: '',
			// View-count popover state + per-social selection values.
			view_count_dropdown_open: false,
			view_count_master: 'manual',
			view_count_methods: {},
			// Cached handler for outside-click cleanup.
			view_count_outside_handler: null,
				merchandise_products: [],
				merchandise_qty: [],
				merchandise_qty_touched: [],
				custom_products: [],
				custom_name_touched: [],
				custom_qty_touched: [],
				max_items_per_milestone: normalizedMaxProducts,
				products: [],
			reward_options: [
				// {
				// 	name: 'Paypal Transfer',
				// 	value: 1
				// },
				{
					name: 'Select reward type',
					value: null,
					selected: true,
					disabled: true
				},
				{
					name: 'Discount',
					value: 2,
					selected: false,
					disabled: false
				},
				{
					name: 'Gift Card',
					value: 3,
					selected: false,
					disabled: false
				},
				{
					name: 'Merchandise',
					value: 4,
					selected: false,
					disabled: false
				},
				{
					name: 'Custom',
					value: 5,
					selected: false,
					disabled: false
				},
				{
					name: 'Cash',
					value: 6,
					selected: false,
					disabled: false
				}
			],

			reward_options_no_products: [
				{
					name: 'Select reward type',
					value: null,
					selected: true,
					disabled: true
				},
				{
					name: 'Custom',
					value: 5,
					selected: false,
					disabled: false
				},
				{
					name: 'Cash',
					value: 6,
					selected: false,
					disabled: false
				}
			],

			rewardFor: [
				{
					value: null,
					name: 'Select the action of rewarding',
					selected: true,
					disabled: true
				},
                {
                    value: 1,
                    name:  'Pay per view',
                    selected: false,
                    disabled: false
                },
				{
					value: 2,
					name: 'Videos count',
					selected: false,
					disabled: false
				},
				{
					value: 3,
					name: 'Images count',
					selected: false,
					disabled: false
				},
				{
					value: 4,
					name: 'Likes count',
					selected: false,
					disabled: false
				}
			],
			allocationType: [
				{
					value: null,
					name: 'Select the allocation type',
					selected: true,
					disabled: true

				},
				{
					value: 1,
					name: 'Last Milestone Achieved',
					selected: false,
					disabled: false

				},
				{
					value: 2,
					name: 'All Achieved Milestones',
					selected: false,
					disabled: false
				}
			],
			reward_type: {
				model: []
			},
			qty: {
				model: []
			},
			discount: {
				model: []
			},
			discount_values: [],
			discount_qty: [],
			discount_values_touched: [],
			discount_qty_touched: [],
			gift_discount: {
				model: []
			},
			cash_value: {
				model: []
			},
			discount_products: [],
			milestones_arr: []
			,
			gift_value_touched: [],
			cash_value_touched: [],
			show_discount_search: [],
			show_merch_search: [],
			missing_discount_products: [],
			missing_merchandise_products: [],
			missing_custom_products: [],
			missing_targets: [],
			missing_reward_types: [],
			invalid_target_sequence: [],
			show_milestone_errors: false,
			reward_type_submitted: [],
			reward_type_previous: [],
			image_upload_errors: {},
			expanded_milestones: {},
			mobile_configuration_open: true,
			mobile_milestones_open: true,
			parent_requirements_met: true,
			flow_update_handler: null
		}
	},

	computed: {
		searchedProducts: function () {
			if (this.inline_search_type === null || this.inline_search_index === null) {
				return []
			}

			const key = this.inlineSearchKey(this.inline_search_type, this.inline_search_index)
			const term = (this.inline_search_terms[key] || '').toLowerCase()

			if (!term || !this.products) {
				return []
			}

			return this.products.filter((result) => {
				return result.name.toLowerCase().match(term)
			})
		},

		selectedRewardType: function () {
			let reward_type_name
			for (let op = 0; op < this.rewardFor.length; op++) {
				if (this.rewardFor[op].value == this.reward_type_for) {
					reward_type_name = this.rewardFor[op].name
				}
			}

			return reward_type_name
		},

		mobileActionSummary: function () {
			const parts = []
			parts.push(this.selectedRewardType || 'Not configured')
			if (this.showViewCountSelection) {
				const countMethod = this.countMethodOptions.find((option) => option.value === this.view_count_master)
				parts.push(countMethod?.label || 'Mixed')
			}
			if (this.allocation_type) {
				const allocation = this.allocationType.find((option) => option.value == this.allocation_type)
				if (allocation?.name) {
					parts.push(allocation.name)
				}
			}
			return parts.join(' · ')
		},

		actionConfigurationComplete: function () {
			if (!this.parent_requirements_met || !this.reward_type_for) {
				return false
			}

			if (this.showCostPerThousandViews) {
				const cost = parseFloat(this.cost_per_x_views)
				return Number.isFinite(cost) && cost >= 0.1
			}

			return Boolean(this.allocation_type)
		},

		hasActionConfigurationErrors: function () {
			return Boolean(
				this.action_of_rewarding_error
				|| this.allocation_type_error
				|| this.cost_per_views_error
				|| this.milestone_errors?.cost_per_x_views?.length
			)
		},

		hasMilestoneConfigurationErrors: function () {
			const total = parseInt(this.milestones_count || 0, 10)
			for (let index = 0; index < total; index += 1) {
				if (this.hasMilestoneErrors(index) || this.hasMilestoneImageErrors(index)) {
					return true
				}
			}

			return Boolean(
				this.show_milestone_errors
				&& (this.isCumulativeSumInvalid() || this.isPerMilestoneLastInvalid())
			)
		},

		refactorRewardOptions: function () {
			if (this.can_add_products == 0) {
				return this.reward_options_no_products
			} else {
				return this.reward_options
			}
		},

		showCostPerThousandViews: function () {
			return this.budget_campaign && this.reward_type_for == 1
		},

		showViewCountSelection: function () {
			return this.reward_type_for == 1 || this.reward_type_for == 4
		},

		countMethodLabel: function () {
			return this.reward_type_for == 4 ? 'Like Count Method' : 'View Count Method'
		},

		countMethodFieldName: function () {
			return this.reward_type_for == 4 ? 'like_count_method' : 'view_count_method'
		},

		countMethodAllFieldName: function () {
			return this.reward_type_for == 4 ? 'like_count_method_all' : 'view_count_method_all'
		},

		currentSavedCountMethods: function () {
			return this.reward_type_for == 4
				? (this.saved_like_count_methods || {})
				: (this.saved_view_count_methods || {})
		},

		currentCountMetric: function () {
			return this.reward_type_for == 4 ? 'like' : 'view'
		},

		// Build list of socials for the popover, filtered by selected socials when available.
		viewCountPlatforms: function () {
			const socials = Array.isArray(this.available_socials_data) ? this.available_socials_data : []
			const selectedKeys = this.viewCountSelectedKeys
			const filteredSocials = selectedKeys.length
				? socials.filter((social) => selectedKeys.includes(String(social.slug || '').toLowerCase()))
				: socials
			const iconMap = {
				tiktok: 'logos:tiktok-icon',
				youtube: 'logos:youtube-icon',
				twitter: 'ri:twitter-x-fill',
				instagram: 'logos:instagram-icon',
				pinterest: 'logos:pinterest',
				facebook: 'logos:facebook'
			}
			// Whether each method is actually available here is asked per segment
			// through methodEnabledFor(), so only presentation is built up here.
			return filteredSocials.map((social) => {
				const key = String(social.slug || '').toLowerCase()
				return {
					key,
					label: key === 'twitter' ? 'X' : (social.name || key),
					icon: iconMap[key] || 'solar:info-circle-linear'
				}
			})
		},

		// Resolve selected social slugs from live DOM updates or draft/back values.
		viewCountSelectedKeys: function () {
			if (Array.isArray(this.selected_socials_live) && this.selected_socials_live.length) {
				return this.selected_socials_live.map((item) => String(item).toLowerCase())
			}
			if (Array.isArray(this.selected_socials_data) && this.selected_socials_data.length) {
				const socials = Array.isArray(this.available_socials_data) ? this.available_socials_data : []
				const mapById = socials.reduce((acc, social) => {
					acc[String(social.id)] = String(social.slug || '').toLowerCase()
					return acc
				}, {})
				return this.selected_socials_data
					.map((item) => mapById[String(item)] || String(item).toLowerCase())
					.filter(Boolean)
			}
			return []
		},

		// The three sources a count can come from. 'manual' is always available;
		// 'auto' needs the stats service to cover the platform and 'api' needs its
		// OAuth keys configured, both answered per platform by the backend.
		countMethodOptions: function () {
			return [
				{ value: 'manual', label: 'Manual', hint: 'Counts are read from the proofs the creator uploads.' },
				{ value: 'auto', label: 'Auto', hint: 'Counts are collected automatically by our stats service.' },
				{ value: 'api', label: 'API', hint: "Counts come from the platform API, using the creator's connected account." }
			]
		}
	},

	watch: {
		// Initialize per-social method values when socials arrive.
		available_socials_data: {
			immediate: true,
			handler(newValue) {
				if (!Array.isArray(newValue)) {
					return
				}
				this.initializeCountMethods()
			}
		},
		'reward_type.model': {
			deep: true,
			handler(newValues) {
				if (!Array.isArray(newValues)) {
					return
				}
				newValues.forEach((value, index) => {
					const normalizedValue = value === null || value === undefined || value === '' ? null : parseInt(value, 10)
					const previousValue = this.reward_type_previous[index] === null || this.reward_type_previous[index] === undefined || this.reward_type_previous[index] === ''
						? null
						: parseInt(this.reward_type_previous[index], 10)
					if (previousValue !== null && previousValue !== normalizedValue) {
						this.resetMilestoneRewardTypeValidationState(index)
					}
					if (value == 2) {
						// Discount rows begin with product search; a row exists only after selection.
						this.ensureDiscountArrays(index)
					}
					if (value == 4) {
						// Merchandise rows begin with product search; a row exists only after selection.
						this.ensureMerchandiseArrays(index)
					}
					if (value == 5) {
						// Custom rewards need no catalog lookup, so render the first editable row immediately.
						this.ensureCustomArrays(index)
						if (!this.custom_products[index] || !this.custom_products[index].length) {
							this.addCustomProduct(index)
						}
					}
					if (value) {
						this.missing_reward_types[index] = false
					}
					this.reward_type_previous[index] = normalizedValue
				})
			}
		},
		'reward_target_value.model': {
			deep: true,
			handler(newValues) {
				if (!Array.isArray(newValues)) {
					return
				}
				newValues.forEach((value, index) => {
					if (value !== null && value !== undefined && value !== '') {
						this.missing_targets[index] = false
					}
				})
			}
		},
		allocation_type(newValue) {
			if (newValue) {
				this.allocation_type_error = ''
			}
		},
		reward_type_for(newValue) {
			if (!this.showCostPerThousandViews) {
				this.cost_per_views_error = ''
			}
			if (newValue) {
				this.action_of_rewarding_error = ''
			}
			if (this.showCostPerThousandViews) {
				this.allocation_type_error = ''
			}
			if (newValue == 1 || newValue == 4) {
				this.initializeCountMethods()
			}
		},
		budget_campaign(newValue) {
			if (!this.showCostPerThousandViews) {
				this.cost_per_views_error = ''
			}
			if (this.showCostPerThousandViews) {
				this.allocation_type_error = ''
			}
            this.rewardFor[1].name = newValue
                ? 'Pay per view'
                : 'Views count';
		}
	},

	methods: {
		milestoneTargetLabel: function (index) {
			const rewardType = String(this.selectedRewardType || '')
				.replace(/\s+count$/i, '')
				.toLowerCase()

			return `Number of ${rewardType || 'items'} in Milestone ${index + 1}`
		},
		milestoneNumber: function (index) {
			return String(index + 1).padStart(2, '0')
		},
		milestoneRewardTypeName: function (index) {
			const selectedValue = this.reward_type.model[index]
			const option = this.refactorRewardOptions.find((rewardOption) => rewardOption.value == selectedValue)

			return option && option.value ? option.name : ''
		},
		isMilestoneExpanded: function (index) {
			return this.expanded_milestones[index] !== false
		},
		toggleMilestone: function (index) {
			this.expanded_milestones[index] = !this.isMilestoneExpanded(index)
		},
		resetMilestoneState: function () {
			this.images = []
			this.reward_type.model = []
			this.reward_target_value.model = []
			this.qty.model = []
			this.gift_discount.model = []
			this.cash_value.model = []
			this.discount.model = []
			this.discount_products = []
			this.discount_values = []
			this.discount_qty = []
			this.discount_values_touched = []
			this.discount_qty_touched = []
			this.merchandise_products = []
			this.merchandise_qty = []
			this.merchandise_qty_touched = []
			this.custom_products = []
			this.custom_name_touched = []
			this.custom_qty_touched = []
			this.show_discount_search = []
			this.show_merch_search = []
			this.missing_targets = []
			this.missing_reward_types = []
			this.invalid_target_sequence = []
			this.missing_discount_products = []
			this.missing_merchandise_products = []
			this.missing_custom_products = []
			this.gift_value_touched = []
			this.cash_value_touched = []
			this.target_touched = []
			this.qty_touched = []
			this.reward_type_submitted = []
			this.reward_type_previous = []
			this.image_upload_errors = {}
			this.cost_per_x_views = ''
			this.cost_per_views_error = ''
			this.cost_per_views_touched = false
			this.show_milestone_errors = false
		},
		resetMilestoneRewardTypeValidationState: function (index) {
			// Reward-type switches should not keep the previous type's validation state alive.
			this.qty_touched[index] = false
			this.gift_value_touched[index] = false
			this.cash_value_touched[index] = false
			this.discount_values_touched[index] = []
			this.discount_qty_touched[index] = []
			this.merchandise_qty_touched[index] = []
			this.custom_name_touched[index] = []
			this.custom_qty_touched[index] = []
			this.missing_discount_products[index] = false
			this.missing_merchandise_products[index] = false
			this.missing_custom_products[index] = false
			this.reward_type_submitted[index] = null

			const prefix = `milestones.${index}.`
			Object.keys(this.milestone_errors || {}).forEach((key) => {
				if (
					key === `${prefix}qty`
					|| key === `${prefix}image`
					|| key === `${prefix}data.products`
					|| key.startsWith(`${prefix}data.`)
				) {
					delete this.milestone_errors[key]
				}
			})

			Object.keys(this.image_upload_errors || {}).forEach((key) => {
				if (key === `${prefix}image` || key.startsWith(`${prefix}data.`)) {
					delete this.image_upload_errors[key]
				}
			})
		},
		onActionOfRewardingChange: function () {
			const current = parseInt(this.reward_type_for)

			// Always start from a clean milestone slate.
			this.resetMilestoneState()

			if (current === this.original_action_of_rewarding) {
				this.keep_original_milestones = true
				this.restore_used === 'old' ? this.setOldValues() : this.setEditValues()
				if (this.original_action_of_rewarding === 1) {
					this.cost_per_x_views = this.restore_used === 'old'
						? (this.set_values?.cost_per_x_views ?? '')
						: (this.campaign_data?.cost_per_x_views ?? '')
				}
			} else {
				this.keep_original_milestones = false
			}

			this.initializeCountMethods()
		},
		methodEnabledFor: function (key, method) {
			if (method !== 'api' && method !== 'auto') {
				return true
			}

			const perMetric = (this.platform_method_availability || {})[this.currentCountMetric]
			const forPlatform = perMetric ? perMetric[key] : null

			if (forPlatform && Object.prototype.hasOwnProperty.call(forPlatform, method)) {
				return !!forPlatform[method]
			}

			if (method === 'api') {
				return !!(this.platform_api_settings || {})[key]
			}

			return !!(this.platform_auto_settings || {})[key]
		},

		// The master offers a method as long as at least one listed platform can use it.
		masterOptionEnabled: function (method) {
			if (method === 'manual') {
				return true
			}
			return this.viewCountPlatforms.some((platform) => this.methodEnabledFor(platform.key, method))
		},

		initializeCountMethods: function () {
			if (!Array.isArray(this.available_socials_data)) {
				return
			}

			const savedMethods = this.currentSavedCountMethods || {}
			const nextMethods = {}

			this.available_socials_data.forEach((social) => {
				const key = String(social.slug || '').toLowerCase()
				const saved = savedMethods[key] || 'manual'
				// A saved method whose source is no longer available falls back to proofs.
				nextMethods[key] = this.methodEnabledFor(key, saved) ? saved : 'manual'
			})

			this.view_count_methods = nextMethods
			this.syncCountMethodMaster()
		},

		// The master reflects only the socials the client can actually see, i.e. the ones
		// selected for this campaign. Comparing across every available social instead would
		// leave the master blank whenever an unselected platform disagreed - invisibly.
		syncCountMethodMaster: function () {
			const values = this.viewCountPlatforms
				.map((platform) => this.view_count_methods[platform.key])
				.filter(Boolean)

			if (!values.length) {
				this.view_count_master = 'manual'
				return
			}

			const first = values[0]
			this.view_count_master = values.every(v => v === first) ? first : null
		},

			clearCostPerViewsError: function () {
				if (this.cost_per_views_error) {
					this.cost_per_views_error = ''
				}
			},
				validateCostPerViewsAgainstMaximum: function () {
				if (!this.showCostPerThousandViews) {
					this.cost_per_views_error = ''
					return true
				}

				const value = this.cost_per_x_views
				const parsed = parseFloat(value)
				if (value === null || value === undefined || value === '' || Number.isNaN(parsed) || parsed < 0.1) {
					if (this.cost_per_views_touched || this.show_milestone_errors) {
						this.cost_per_views_error = 'The cost per 1000 views field must be a minimum of 0.1$.'
						return false
					}

					this.cost_per_views_error = ''
					return true
				}

				if (this.maximum_reward_per_video !== null && parsed > this.maximum_reward_per_video) {
					this.cost_per_views_error = 'Cost per 1000 views cannot exceed the maximum reward per influencer.'
					return false
				}

					this.cost_per_views_error = ''
					return true
				},
				getMilestoneItemLimitMessage: function () {
					return `You can add a maximum of ${this.max_items_per_milestone} items per milestone.`
				},
				getMilestoneItemCount: function (type, index) {
					if (type == 2) {
						return Array.isArray(this.discount_products[index]) ? this.discount_products[index].length : 0
					}
					if (type == 4) {
						return Array.isArray(this.merchandise_products[index]) ? this.merchandise_products[index].length : 0
					}
					if (type == 5) {
						return Array.isArray(this.custom_products[index]) ? this.custom_products[index].length : 0
					}
					return 0
				},
				hasReachedMilestoneItemLimit: function (type, index) {
					return this.getMilestoneItemCount(type, index) >= this.max_items_per_milestone
				},
				ensureDiscountArrays: function (index) {
			// Initialize per-milestone discount arrays for multi-product inputs.
			if (!this.discount_products[index]) {
				this.discount_products[index] = [];
			}
			if (!this.discount_values[index]) {
				this.discount_values[index] = [];
			}
			if (!this.discount_qty[index]) {
				this.discount_qty[index] = [];
			}
			if (!this.discount_values_touched[index]) {
				this.discount_values_touched[index] = [];
			}
			if (!this.discount_qty_touched[index]) {
				this.discount_qty_touched[index] = [];
			}
			if (this.show_discount_search[index] === undefined) {
				this.show_discount_search[index] = true;
			}
		},

		ensureMerchandiseArrays: function (index) {
			// Initialize per-milestone merchandise arrays for multi-product inputs.
			if (!this.merchandise_products[index]) {
				this.merchandise_products[index] = [];
			}
			if (!this.merchandise_qty[index]) {
				this.merchandise_qty[index] = [];
			}
			if (!this.merchandise_qty_touched[index]) {
				this.merchandise_qty_touched[index] = [];
			}
			if (this.show_merch_search[index] === undefined) {
				this.show_merch_search[index] = true;
			}
		},

		ensureCustomArrays: function (index) {
			// Initialize per-milestone custom arrays for addable rows.
			if (!this.custom_products[index]) {
				this.custom_products[index] = [];
			}
			if (!this.custom_name_touched[index]) {
				this.custom_name_touched[index] = [];
			}
			if (!this.custom_qty_touched[index]) {
				this.custom_qty_touched[index] = [];
			}
		},
		// Toggle the popover visibility.
		toggleViewCountDropdown: function () {
			this.view_count_dropdown_open = !this.view_count_dropdown_open
		},

		// Master applies one method to every social, leaving on 'manual' the ones
		// that cannot use it - the same rule the backend enforces on save.
		setCountMethodForAll: function (method) {
			Object.keys(this.view_count_methods).forEach((key) => {
				this.view_count_methods[key] = this.methodEnabledFor(key, method) ? method : 'manual'
			})
			// Re-derived rather than assigned: when some socials could not take the method
			// they stay on 'manual', and the master must not claim otherwise.
			this.syncCountMethodMaster()
		},

		// Single social selection updates only that platform.
		setCountMethodFor: function (key, method) {
			if (!this.methodEnabledFor(key, method)) {
				return
			}
			this.view_count_methods[key] = method
			this.syncCountMethodMaster()
		},

		// Close popover on outside interaction.
		handleViewCountOutsideClick: function (event) {
			if (!this.view_count_dropdown_open) {
				return
			}
			const container = this.$el ? this.$el.querySelector('.view-count-selection') : null
			const path = event.composedPath ? event.composedPath() : []
			const clickedInside = container && (container.contains(event.target) || path.includes(container))
			if (!clickedInside) {
				this.view_count_dropdown_open = false
			}
		},

		checkValue: function (index, ev) {
			this.target_touched[index] = true
			const prevValue = this.reward_target_value.model[index - 1]
			const prevMaxValue = this.reward_target_value.model
				.slice(0, index)
				.reduce((max, val) => {
					const num = val === null || val === undefined || val === '' ? null : Number(val)
					if (Number.isNaN(num) || num === null) {
						return max
					}
					return max === null || num > max ? num : max
				}, null)
			const currentValue = this.reward_target_value.model[index]
			if ((prevMaxValue !== null && currentValue && prevMaxValue >= currentValue) || (prevValue && currentValue && prevValue >= currentValue)) {
				this.invalid_target_sequence[index] = true
			} else {
				this.invalid_target_sequence[index] = false
			}
		},

		sanitizeIntegerInput: function (event, field, index, subIndex = null) {
			const target = event?.target
			if (!target) {
				return
			}
			let value = String(target.value ?? '')
			value = value.replace(/\D+/g, '')
			value = value.replace(/^0+/, '')
			target.value = value

			const parsed = value === '' ? null : parseInt(value, 10)
			if (field === 'target') {
				this.reward_target_value.model[index] = parsed
			} else if (field === 'qty') {
				this.qty.model[index] = parsed
			} else if (field === 'discount_qty' && subIndex !== null) {
				if (!this.discount_qty[index]) {
					this.discount_qty[index] = []
				}
				this.discount_qty[index][subIndex] = parsed
			} else if (field === 'merch_qty' && subIndex !== null) {
				if (!this.merchandise_qty[index]) {
					this.merchandise_qty[index] = []
				}
				this.merchandise_qty[index][subIndex] = parsed
			} else if (field === 'custom_qty' && subIndex !== null) {
				if (this.custom_products[index] && this.custom_products[index][subIndex]) {
					this.custom_products[index][subIndex].qty = parsed
				}
			}
		},
		setImageUploadError(path, message) {
			if (!path) {
				return
			}
			if (message) {
				this.image_upload_errors[path] = message
				return
			}
			delete this.image_upload_errors[path]
		},

		imageFieldError(path) {
			if (this.image_upload_errors && this.image_upload_errors[path]) {
				return this.image_upload_errors[path]
			}
			if (this.milestone_errors && this.milestone_errors[path]) {
				return this.milestone_errors[path][0]
			}
			return ''
		},

		getMilestoneImageMaxDimension: function () {
			const parsed = parseInt(this.image_upload_max?.milestone, 10)
			return Number.isFinite(parsed) && parsed > 0 ? parsed : null
		},

		getImageDimensions: function (file) {
			return new Promise((resolve, reject) => {
				const objectUrl = URL.createObjectURL(file)
				const image = new Image()

				image.onload = () => {
					const dimensions = {
						width: image.naturalWidth,
						height: image.naturalHeight
					}
					URL.revokeObjectURL(objectUrl)
					resolve(dimensions)
				}

				image.onerror = () => {
					URL.revokeObjectURL(objectUrl)
					reject(new Error('Unable to read image dimensions.'))
				}

				image.src = objectUrl
			})
		},

		validateMilestoneImageFile: async function (file, errorPath, input) {
			// Images stay optional; this only validates files when the user actually selects one.
			this.setImageUploadError(errorPath, null)
			if (!file) {
				return false
			}

			const allowedMimeTypes = ['image/jpeg', 'image/png']
			const hasAllowedMimeType = !file.type || allowedMimeTypes.includes(file.type)
			const hasAllowedExtension = /\.(jpe?g|png)$/i.test(file.name || '')

			if (!hasAllowedMimeType || !hasAllowedExtension) {
				this.setImageUploadError(errorPath, this.milestone_image_help_text)
				if (input) {
					input.value = ''
				}
				return false
			}

			const maxDimension = this.getMilestoneImageMaxDimension()
			if (maxDimension) {
				try {
					const { width, height } = await this.getImageDimensions(file)
					if (width > maxDimension || height > maxDimension) {
						this.setImageUploadError(errorPath, `Image must not be larger than ${maxDimension}x${maxDimension}px.`)
						if (input) {
							input.value = ''
						}
						return false
					}
				} catch (error) {
					this.setImageUploadError(errorPath, 'Unable to validate the selected image.')
					if (input) {
						input.value = ''
					}
					return false
				}
			}

			return true
		},

		onFileChange: async function (event, index) {
			const file = event.target.files[0]
			const errorPath = `milestones.${index}.image`
			this.images[index] = []

			if (!await this.validateMilestoneImageFile(file, errorPath, event.target)) {
				return
			}

			const url = URL.createObjectURL(file)
			if (!this.images[index]) {
				this.images[index] = []
			}
			this.images[index].push(url)
		},

		onDiscountImageChange: async function (event, index, discountIndex) {
			// Store a local preview for discount product uploads.
			const file = event.target.files[0];
			const errorPath = `milestones.${index}.data.${discountIndex}.image`
			if (!file) {
				this.setImageUploadError(errorPath, null)
				return;
			}
			if (!await this.validateMilestoneImageFile(file, errorPath, event.target)) {
				return
			}

			if (!this.discount_products[index] || !this.discount_products[index][discountIndex]) {
				return;
			}

			this.discount_products[index][discountIndex].preview_url = URL.createObjectURL(file);
		},

		onMerchandiseImageChange: async function (event, index, merchIndex) {
			// Store a local preview for merchandise product uploads.
			const file = event.target.files[0];
			const errorPath = `milestones.${index}.data.products.${merchIndex}.image`
			if (!file) {
				this.setImageUploadError(errorPath, null)
				return;
			}
			if (!await this.validateMilestoneImageFile(file, errorPath, event.target)) {
				return
			}

			if (!this.merchandise_products[index] || !this.merchandise_products[index][merchIndex]) {
				return;
			}

			this.merchandise_products[index][merchIndex].preview_url = URL.createObjectURL(file);
		},

		onCustomImageChange: async function (event, index, customIndex) {
			// Store a local preview for custom product uploads.
			const file = event.target.files[0];
			const errorPath = `milestones.${index}.data.${customIndex}.image`
			if (!file) {
				this.setImageUploadError(errorPath, null)
				return;
			}
			if (!await this.validateMilestoneImageFile(file, errorPath, event.target)) {
				return
			}

			if (!this.custom_products[index] || !this.custom_products[index][customIndex]) {
				return;
			}

			this.custom_products[index][customIndex].preview_url = URL.createObjectURL(file);
		},

		clearDiscountImage: function (index, discountIndex) {
			// Clear discount product image and reset file input.
			if (!this.discount_products[index] || !this.discount_products[index][discountIndex]) {
				return
			}
			this.discount_products[index][discountIndex].preview_url = null
			this.discount_products[index][discountIndex].image = null
			this.setImageUploadError(`milestones.${index}.data.${discountIndex}.image`, null)
			const input = document.getElementById(`milestones_${index}_discount_${discountIndex}_image`)
			if (input) {
				input.value = ''
			}
		},

		clearMerchImage: function (index, merchIndex) {
			// Clear merchandise product image and reset file input.
			if (!this.merchandise_products[index] || !this.merchandise_products[index][merchIndex]) {
				return
			}
			this.merchandise_products[index][merchIndex].preview_url = null
			this.merchandise_products[index][merchIndex].image = null
			this.setImageUploadError(`milestones.${index}.data.products.${merchIndex}.image`, null)
			const input = document.getElementById(`milestones_${index}_merch_${merchIndex}_image`)
			if (input) {
				input.value = ''
			}
		},

		clearCustomImage: function (index, customIndex) {
			// Clear custom product image and reset file input.
			if (!this.custom_products[index] || !this.custom_products[index][customIndex]) {
				return
			}
			this.custom_products[index][customIndex].preview_url = null
			this.custom_products[index][customIndex].image = null
			this.setImageUploadError(`milestones.${index}.data.${customIndex}.image`, null)
			const input = document.getElementById(`milestones_${index}_custom_${customIndex}_image`)
			if (input) {
				input.value = ''
			}
		},

		clearMilestoneImage: function (index, type) {
			// Clear gift/cash milestone image and reset file input.
			this.images[index] = []
			this.setImageUploadError(`milestones.${index}.image`, null)
			const inputId = type === 'gift'
				? `milestones_${index}_gift_image`
				: `milestones_${index}_cash_image`
			const input = document.getElementById(inputId)
			if (input) {
				input.value = ''
			}
		},


		// link: /shoppable/get-products?search= + search (3 letters <) 'product'
		dataQuery: async function (search, type, index) {
			// Discount and merchandise reuse one results array, so track the active search box explicitly.
			this.inline_search_type = type
			this.inline_search_index = index
			if (search.length > 3) {
				this.is_typing = true
				await axios.get('/shoppable/get-products', { params: { search, uuid: this.campaign?.uuid } })
					.then((response) => {
						this.products = response.data.products

						this.is_typing = false
					})
					.catch(() => {
						this.products = []
						this.is_typing = false
					})
			} else {
				if (search.length === 0) {
					this.products = []
					this.is_typing = false
				}
			}
		},

		inlineSearchKey(type, index) {
			return `t${type}-i${index}`
		},

		openInlineSearch(type, index) {
			const key = this.inlineSearchKey(type, index)
			if (this.inline_search_terms[key] === undefined) {
				this.inline_search_terms[key] = ''
			}
			// Reset stale results when switching between different inline search contexts.
			const isSwitchingSearchContext =
				this.inline_search_type !== null &&
				this.inline_search_index !== null &&
				(this.inline_search_type !== type || this.inline_search_index !== index)

			if (isSwitchingSearchContext) {
				this.products = []
				this.is_typing = false
			}
			this.inline_search_type = type
			this.inline_search_index = index
		},

		closeInlineSearch(type, index) {
			const key = this.inlineSearchKey(type, index)
			this.inline_search_type = null
			this.inline_search_index = null
			this.inline_search_terms[key] = ''
			this.products = []
		},

		clearInlineSearchTerm(type, index) {
			const key = this.inlineSearchKey(type, index)
			this.inline_search_terms[key] = ''
			this.products = []
		},

		initToast: function (type) {
			if (window.toastr) {
				if (type === 'success') {
					window.toastr.success('Product added successfully!', '', { timeOut: 1700 })
				} else if (type === 'exists') {
					window.toastr.info('Product already added!', '', { timeOut: 1700 })
				} else {
					window.toastr.error('Product removed', '', { timeOut: 1700 })
				}
				return
			}

			this.notifications_toast = document.getElementById('notificationToast')
			let toastElement = bootstrap.Toast.getOrCreateInstance(this.notifications_toast)
			this.notification_type = type

			if (type === 'success') {
				this.notification_message = 'Product added successfully!'
			} else if (type === 'exists') {
				this.notification_message = 'Product already added!'
			} else {
				this.notification_message = 'Product removed'
			}

			toastElement.show()
		},


			selectProduct: function (item, type_value, loop_index) {
				// Add a product to the correct reward type collection.
				if (type_value == 2) {
					this.ensureDiscountArrays(loop_index)
					let discountExists = this.discount_products[loop_index].find((el) => { return el.id === item.id })
					if (!discountExists && this.hasReachedMilestoneItemLimit(2, loop_index)) {
						return
					}
					if (!discountExists) {
						this.discount_products[loop_index].push(item)
					this.missing_discount_products[loop_index] = false
					const productIndex = this.discount_products[loop_index].length - 1
					this.discount_values[loop_index][productIndex] = null
					this.discount_qty[loop_index][productIndex] = null
					this.discount_values_touched[loop_index][productIndex] = false
					this.discount_qty_touched[loop_index][productIndex] = false
					this.show_discount_search[loop_index] = false

					this.clearInlineSearchTerm(2, loop_index)
					this.initToast('success')
				} else {
					this.initToast('exists')
				}
				return
			}

			if (!this.merchandise_products[loop_index]) {
				this.merchandise_products[loop_index] = []
			}

				let merchExists = this.merchandise_products[loop_index].find((el) => { return el.id === item.id })

				if (type_value == 4 && !merchExists) {
					if (this.hasReachedMilestoneItemLimit(4, loop_index)) {
						return
					}
					this.ensureMerchandiseArrays(loop_index)
					this.merchandise_products[loop_index].push(item)
				this.missing_merchandise_products[loop_index] = false
				const merchIndex = this.merchandise_products[loop_index].length - 1
				this.merchandise_qty[loop_index][merchIndex] = null
				this.merchandise_qty_touched[loop_index][merchIndex] = false
				this.show_merch_search[loop_index] = false

				this.clearInlineSearchTerm(4, loop_index)
				this.initToast('success')
			} else {
				if (merchExists) {
					this.initToast('exists')
				}
			}
		},

		deleteItem: function (item, loop_index, localIndex) {
			// Remove a merchandise product and keep its arrays in sync.

			if (this.merchandise_products[loop_index][localIndex] === item) {
				this.merchandise_products[loop_index].splice(localIndex, 1)
			} else {
				let found = this.merchandise_products[loop_index].indexOf(item)
				this.merchandise_products[loop_index].splice(found, 1)
			}
			if (this.merchandise_qty[loop_index]) {
				this.merchandise_qty[loop_index].splice(localIndex, 1)
			}
			if (this.merchandise_qty_touched[loop_index]) {
				this.merchandise_qty_touched[loop_index].splice(localIndex, 1)
			}
			if (!this.merchandise_products[loop_index].length) {
				this.missing_merchandise_products[loop_index] = true
				this.show_merch_search[loop_index] = true
			}

			this.initToast('delete')
		},

		hasMerchErrors: function (index, merchIndex) {
			// Aggregate client/server errors for merchandise rows.
			const touchedQty = this.merchandise_qty_touched[index] && this.merchandise_qty_touched[index][merchIndex]
			const qtyInvalid = this.merchandise_qty[index] && this.merchandise_qty[index][merchIndex] < 1
			const serverQtyErr = this.milestone_errors[`milestones.${index}.data.products.${merchIndex}.qty`]

			return (touchedQty && qtyInvalid) || serverQtyErr
		},

		deleteDiscountProduct: function (loop_index, product_index) {
			// Remove a discount product and keep its arrays in sync.
			if (!this.discount_products[loop_index]) {
				return
			}

			this.discount_products[loop_index].splice(product_index, 1)
			if (this.discount_values[loop_index]) {
				this.discount_values[loop_index].splice(product_index, 1)
			}
			if (this.discount_qty[loop_index]) {
				this.discount_qty[loop_index].splice(product_index, 1)
			}
			if (this.discount_values_touched[loop_index]) {
				this.discount_values_touched[loop_index].splice(product_index, 1)
			}
			if (this.discount_qty_touched[loop_index]) {
				this.discount_qty_touched[loop_index].splice(product_index, 1)
			}
			if (!this.discount_products[loop_index].length) {
				this.missing_discount_products[loop_index] = true
				this.show_discount_search[loop_index] = true
			}
			this.initToast('delete')
		},

		hasDiscountErrors: function (index, discountIndex) {
			// Aggregate client/server errors for discount rows.
			const touchedValue = this.discount_values_touched[index] && this.discount_values_touched[index][discountIndex]
			const touchedQty = this.discount_qty_touched[index] && this.discount_qty_touched[index][discountIndex]
			const valueInvalid = this.discount_values[index] && (this.discount_values[index][discountIndex] < 1 || this.discount_values[index][discountIndex] > 100)
			const qtyInvalid = this.discount_qty[index] && this.discount_qty[index][discountIndex] < 1
			const serverValueErr = this.milestone_errors[`milestones.${index}.data.${discountIndex}.discount_value`]
			const serverQtyErr = this.milestone_errors[`milestones.${index}.data.${discountIndex}.qty`]
			const serverProductErr = this.milestone_errors[`milestones.${index}.data.${discountIndex}.discount_product_id`]

			return (touchedValue && valueInvalid) || (touchedQty && qtyInvalid) || serverValueErr || serverQtyErr || serverProductErr
		},

		hasCustomErrors: function (index, customIndex) {
			// Aggregate client/server errors for custom rows.
			const touchedName = this.custom_name_touched[index] && this.custom_name_touched[index][customIndex]
			const touchedQty = this.custom_qty_touched[index] && this.custom_qty_touched[index][customIndex]
			const nameInvalid = this.custom_products[index] && !this.custom_products[index][customIndex]?.name
			const qtyInvalid = this.custom_products[index] && this.custom_products[index][customIndex]?.qty < 1
			const serverNameErr = this.milestone_errors[`milestones.${index}.data.${customIndex}.name`]
			const serverQtyErr = this.milestone_errors[`milestones.${index}.data.${customIndex}.qty`]

			return (touchedName && nameInvalid) || (touchedQty && qtyInvalid) || serverNameErr || serverQtyErr
		},

		hasGiftErrors: function (index) {
			// Aggregate client/server errors for gift rows.
			const touchedValue = this.gift_value_touched[index]
			const value = this.gift_discount.model[index]
			const valueInvalid = value === null || value === undefined || value === '' || value < 1
			const serverErr = this.milestone_errors[`milestones.${index}.data.gift_card_value`]

			return (touchedValue && valueInvalid) || serverErr
		},

		hasCashErrors: function (index) {
			// Aggregate client/server errors for cash rows.
			const touchedValue = this.cash_value_touched[index]
			const value = this.cash_value.model[index]
			const valueInvalid = value === null || value === undefined || value === '' || value < 1
			const serverErr = this.milestone_errors[`milestones.${index}.data.cash_value`]

			return (touchedValue && valueInvalid) || serverErr
		},

		isTargetInvalid: function (index) {
			const value = this.reward_target_value.model[index]
			const touched = this.show_milestone_errors || this.target_touched[index] || this.missing_targets[index]
			if (!touched) {
				return false
			}
			return value === null || value === undefined || value === '' || value < 1 || !Number.isInteger(Number(value))
		},

		shouldShowRewardTypeErrors: function (index, rewardType) {
			if (this.budget_campaign) {
				return false
			}
			if (this.show_milestone_errors && this.reward_type_submitted[index] === rewardType) {
				return true
			}
			return false
		},

		isRewardTypeInvalid: function (index) {
			if (!this.pag_campaign) {
				return false
			}
			if (!this.show_milestone_errors && !this.missing_reward_types[index]) {
				return false
			}
			return !this.reward_type.model[index]
		},

		isBudgetQtyInvalid: function (index) {
			if (!this.budget_campaign) {
				return false
			}
			const touched = this.show_milestone_errors || this.qty_touched[index]
			if (!touched) {
				return false
			}
			const value = this.qty.model[index]
			if (value === null || value === undefined || value === '' || value < 1 || value > 999999) {
				return true
			}
			if (this.allocation_type == 1 && this.maximum_reward_per_video !== null && parseFloat(value) > this.maximum_reward_per_video) {
				return true
			}
			return false
		},

			isCumulativeSumInvalid: function () {
				if (
					!this.budget_campaign
					|| this.showCostPerThousandViews
					|| this.allocation_type != 2
					|| this.maximum_reward_per_video === null
				) {
					return false
				}
				const total = parseInt(this.milestones_count || 0, 10)
				let sum = 0
				for (let i = 0; i < total; i++) {
				sum += parseFloat(this.qty.model[i]) || 0
			}
			return Math.abs(sum - this.maximum_reward_per_video) > 0.01
		},

			isPerMilestoneLastInvalid: function () {
				if (
					!this.budget_campaign
					|| this.showCostPerThousandViews
					|| this.allocation_type != 1
					|| this.maximum_reward_per_video === null
				) {
					return false
				}
				const total = parseInt(this.milestones_count || 0, 10)
				if (total < 1) return false
			const lastQty = parseFloat(this.qty.model[total - 1]) || 0
			return Math.abs(lastQty - this.maximum_reward_per_video) > 0.01
		},

		isStandardQtyInvalid: function (index) {
			if (this.budget_campaign) {
				return false
			}
			const rewardType = this.reward_type.model[index]
			if (!rewardType || rewardType == 2 || rewardType == 4 || rewardType == 5) {
				return false
			}
			const touched = this.qty_touched[index] || this.shouldShowRewardTypeErrors(index, rewardType)
			if (!touched) {
				return false
			}
			const value = this.qty.model[index]
			return value === null || value === undefined || value === '' || value < 1 || !Number.isInteger(Number(value))
		},

		isDiscountValueInvalid: function (index, discountIndex) {
			if (!this.discount_products[index] || !this.discount_products[index].length) {
				return false
			}
			const touched = (this.discount_values_touched[index] && this.discount_values_touched[index][discountIndex])
				|| this.shouldShowRewardTypeErrors(index, 2)
			if (!touched) {
				return false
			}
			const value = this.discount_values[index] ? this.discount_values[index][discountIndex] : null
			return value === null || value === undefined || value === '' || value < 1 || value > 100
		},

		isDiscountQtyInvalid: function (index, discountIndex) {
			if (!this.discount_products[index] || !this.discount_products[index].length) {
				return false
			}
			const touched = (this.discount_qty_touched[index] && this.discount_qty_touched[index][discountIndex])
				|| this.shouldShowRewardTypeErrors(index, 2)
			if (!touched) {
				return false
			}
			const value = this.discount_qty[index] ? this.discount_qty[index][discountIndex] : null
			return value === null || value === undefined || value === '' || value < 1
		},

		isDiscountSearchInvalid: function (index) {
			if (this.budget_campaign) {
				return false
			}
			if (this.reward_type.model[index] != 2) {
				return false
			}
			if (!this.shouldShowRewardTypeErrors(index, 2)) {
				return false
			}
			return !this.discount_products[index] || !this.discount_products[index].length
		},

		isGiftValueInvalid: function (index) {
			const touched = this.gift_value_touched[index] || this.shouldShowRewardTypeErrors(index, 3)
			if (!touched) {
				return false
			}
			const value = this.gift_discount.model[index]
			return value === null || value === undefined || value === '' || value < 1
		},

		isCashValueInvalid: function (index) {
			const touched = this.cash_value_touched[index] || this.shouldShowRewardTypeErrors(index, 6)
			if (!touched) {
				return false
			}
			const value = this.cash_value.model[index]
			return value === null || value === undefined || value === '' || value < 1
		},

		isMerchQtyInvalid: function (index, merchIndex) {
			if (!this.merchandise_products[index] || !this.merchandise_products[index].length) {
				return false
			}
			const touched = (this.merchandise_qty_touched[index] && this.merchandise_qty_touched[index][merchIndex])
				|| this.shouldShowRewardTypeErrors(index, 4)
			if (!touched) {
				return false
			}
			const value = this.merchandise_qty[index] ? this.merchandise_qty[index][merchIndex] : null
			return value === null || value === undefined || value === '' || value < 1
		},

		isMerchSearchInvalid: function (index) {
			if (this.budget_campaign) {
				return false
			}
			if (this.reward_type.model[index] != 4) {
				return false
			}
			if (!this.shouldShowRewardTypeErrors(index, 4)) {
				return false
			}
			return !this.merchandise_products[index] || !this.merchandise_products[index].length
		},

		isCustomNameInvalid: function (index, customIndex) {
			const touched = (this.custom_name_touched[index] && this.custom_name_touched[index][customIndex])
				|| this.shouldShowRewardTypeErrors(index, 5)
			if (!touched) {
				return false
			}
			const item = this.custom_products[index] ? this.custom_products[index][customIndex] : null
			return !item || !item.name
		},

		isCustomQtyInvalid: function (index, customIndex) {
			const touched = (this.custom_qty_touched[index] && this.custom_qty_touched[index][customIndex])
				|| this.shouldShowRewardTypeErrors(index, 5)
			if (!touched) {
				return false
			}
			const item = this.custom_products[index] ? this.custom_products[index][customIndex] : null
			const value = item ? item.qty : null
			return value === null || value === undefined || value === '' || value < 1
		},

		getMilestoneErrors: function (index) {
			const errors = []
			const seen = new Set()
			const addError = (message) => {
				if (!message) {
					return
				}
				const key = String(message).trim()
				if (!key || seen.has(key)) {
					return
				}
				seen.add(key)
				errors.push(key)
			}
			const serverError = (path) => {
				const value = this.milestone_errors ? this.milestone_errors[path] : null
				if (Array.isArray(value) && value.length) {
					return value[0]
				}
				if (typeof value === 'string') {
					return value
				}
				return null
			}
			const imageError = (path) => {
				return this.image_upload_errors ? this.image_upload_errors[path] : null
			}

			const rewardType = this.reward_type.model[index]
			const targetValue = this.reward_target_value.model[index]
			const prevTargetValue = this.reward_target_value.model[index - 1]
			const prevMaxTargetValue = this.reward_target_value.model
				.slice(0, index)
				.reduce((max, val) => {
					const num = val === null || val === undefined || val === '' ? null : Number(val)
					if (Number.isNaN(num) || num === null) {
						return max
					}
					return max === null || num > max ? num : max
				}, null)
			const hasServerErrors = Object.keys(this.milestone_errors || {}).some((key) => key.startsWith(`milestones.${index}.`))
			const shouldShow = this.show_milestone_errors || hasServerErrors
				|| this.target_touched[index]
				|| this.qty_touched[index]
				|| this.discount_values_touched[index]?.some(Boolean)
				|| this.discount_qty_touched[index]?.some(Boolean)
				|| this.merchandise_qty_touched[index]?.some(Boolean)
				|| this.custom_name_touched[index]?.some(Boolean)
				|| this.custom_qty_touched[index]?.some(Boolean)
				|| this.gift_value_touched[index]
				|| this.cash_value_touched[index]
				|| this.missing_targets[index]
				|| this.missing_reward_types[index]
				|| this.missing_discount_products[index]
				|| this.missing_merchandise_products[index]
				|| this.missing_custom_products[index]

			if (!shouldShow) {
				return errors
			}

			const targetTouched = this.target_touched[index] || this.missing_targets[index]

			if (targetTouched) {
				if (targetValue === null || targetValue === undefined || targetValue === '') {
					addError('Milestone target is required')
				} else if (targetValue < 1) {
					addError('Value must be higher than 0')
				}
			}

			if (this.invalid_target_sequence[index] || (prevMaxTargetValue !== null && targetValue && prevMaxTargetValue >= targetValue)) {
				addError('Value already exists or is smaller than the previous.')
			}

			if (this.budget_campaign) {
				const qtyTouched = this.qty_touched[index] || serverError(`milestones.${index}.qty`)
				const qtyValue = this.qty.model[index]
				if (qtyTouched && (qtyValue === null || qtyValue === undefined || qtyValue === '' || qtyValue < 1)) {
					addError('Amount value must be at least 1$')
				} else if (qtyTouched && qtyValue > 999999) {
					addError('Amount value must not be greater than 999999$')
				}
				addError(serverError(`milestones.${index}.target`))
				addError(serverError(`milestones.${index}.qty`))
				return errors
			}

			if (this.pag_campaign && !rewardType) {
				addError('Reward type is required')
			}

			const showDiscountErrors = this.shouldShowRewardTypeErrors(index, 2)
				|| this.discount_values_touched[index]?.some(Boolean)
				|| this.discount_qty_touched[index]?.some(Boolean)

			const showMerchErrors = this.shouldShowRewardTypeErrors(index, 4)
				|| this.merchandise_qty_touched[index]?.some(Boolean)

			const showCustomErrors = this.shouldShowRewardTypeErrors(index, 5)
				|| this.custom_name_touched[index]?.some(Boolean)
				|| this.custom_qty_touched[index]?.some(Boolean)

			const showGiftErrors = this.shouldShowRewardTypeErrors(index, 3) || this.gift_value_touched[index]
			const showCashErrors = this.shouldShowRewardTypeErrors(index, 6) || this.cash_value_touched[index]

			if (showDiscountErrors && this.missing_discount_products[index]) {
				addError('Please add at least one discount product')
			}

			if (showMerchErrors && this.missing_merchandise_products[index]) {
				addError('Please add at least one merchandise product')
			}

			if (showCustomErrors && this.missing_custom_products[index]) {
				addError('Please add at least one custom product')
			}

			if (rewardType && rewardType != 2 && rewardType != 4 && rewardType != 5) {
				const qtyValue = this.qty.model[index]
				const qtyTouched = this.qty_touched[index] || this.shouldShowRewardTypeErrors(index, rewardType)
				if (qtyTouched && (qtyValue === null || qtyValue === undefined || qtyValue === '' || qtyValue < 1)) {
					addError('Amount value must be at least 1')
				}
			}

			if (showDiscountErrors && rewardType == 2 && Array.isArray(this.discount_products[index]) && this.discount_products[index].length) {
				this.discount_products[index].forEach((_, discountIndex) => {
					const discountValue = this.discount_values[index] ? this.discount_values[index][discountIndex] : null
					const discountQty = this.discount_qty[index] ? this.discount_qty[index][discountIndex] : null
					const valueTouched = this.discount_values_touched[index] && this.discount_values_touched[index][discountIndex]
					const qtyTouched = this.discount_qty_touched[index] && this.discount_qty_touched[index][discountIndex]

					if ((this.shouldShowRewardTypeErrors(index, 2) || valueTouched) && (discountValue === null || discountValue === undefined || discountValue === '' || discountValue < 1 || discountValue > 100)) {
						addError(`Discount #${discountIndex + 1}: Discount value must be between 1 and 100`)
					}

					if ((this.shouldShowRewardTypeErrors(index, 2) || qtyTouched) && (discountQty === null || discountQty === undefined || discountQty === '' || discountQty < 1)) {
						addError(`Discount #${discountIndex + 1}: Amount value must be at least 1`)
					}

					addError(serverError(`milestones.${index}.data.${discountIndex}.discount_value`) ? `Discount #${discountIndex + 1}: ${serverError(`milestones.${index}.data.${discountIndex}.discount_value`)}` : null)
					addError(serverError(`milestones.${index}.data.${discountIndex}.qty`) ? `Discount #${discountIndex + 1}: ${serverError(`milestones.${index}.data.${discountIndex}.qty`)}` : null)
					addError(serverError(`milestones.${index}.data.${discountIndex}.discount_product_id`) ? `Discount #${discountIndex + 1}: ${serverError(`milestones.${index}.data.${discountIndex}.discount_product_id`)}` : null)
				})
			}



			if (showMerchErrors && rewardType == 4 && Array.isArray(this.merchandise_products[index]) && this.merchandise_products[index].length) {
				this.merchandise_products[index].forEach((_, merchIndex) => {
					const qtyValue = this.merchandise_qty[index] ? this.merchandise_qty[index][merchIndex] : null
					const qtyTouched = this.merchandise_qty_touched[index] && this.merchandise_qty_touched[index][merchIndex]
					if ((this.shouldShowRewardTypeErrors(index, 4) || qtyTouched) && (qtyValue === null || qtyValue === undefined || qtyValue === '' || qtyValue < 1)) {
						addError(`Merchandise #${merchIndex + 1}: Amount value must be at least 1`)
					}
					addError(serverError(`milestones.${index}.data.products.${merchIndex}.qty`) ? `Merchandise #${merchIndex + 1}: ${serverError(`milestones.${index}.data.products.${merchIndex}.qty`)}` : null)
				})
			}



			if (showCustomErrors && rewardType == 5 && Array.isArray(this.custom_products[index]) && this.custom_products[index].length) {
				this.custom_products[index].forEach((item, customIndex) => {
					const nameTouched = this.custom_name_touched[index] && this.custom_name_touched[index][customIndex]
					const qtyTouched = this.custom_qty_touched[index] && this.custom_qty_touched[index][customIndex]
					const nameValue = item ? item.name : null
					const qtyValue = item ? item.qty : null
					if ((this.shouldShowRewardTypeErrors(index, 5) || nameTouched) && (!nameValue || nameValue === '')) {
						addError(`Custom #${customIndex + 1}: Name is required`)
					}
					if ((this.shouldShowRewardTypeErrors(index, 5) || qtyTouched) && (qtyValue === null || qtyValue === undefined || qtyValue === '' || qtyValue < 1)) {
						addError(`Custom #${customIndex + 1}: Amount value must be at least 1`)
					}
					addError(serverError(`milestones.${index}.data.${customIndex}.name`) ? `Custom #${customIndex + 1}: ${serverError(`milestones.${index}.data.${customIndex}.name`)}` : null)
					addError(serverError(`milestones.${index}.data.${customIndex}.qty`) ? `Custom #${customIndex + 1}: ${serverError(`milestones.${index}.data.${customIndex}.qty`)}` : null)
				})
			}



			if (rewardType == 3 && showGiftErrors) {
				const value = this.gift_discount.model[index]
				if ((this.shouldShowRewardTypeErrors(index, 3) || this.gift_value_touched[index]) && (value === null || value === undefined || value === '' || value < 1)) {
					addError('Gift Card value must be at least 1')
				}
				addError(serverError(`milestones.${index}.data.gift_card_value`))
			}

			if (rewardType == 6 && showCashErrors) {
				const value = this.cash_value.model[index]
				if ((this.shouldShowRewardTypeErrors(index, 6) || this.cash_value_touched[index]) && (value === null || value === undefined || value === '' || value < 1)) {
					addError('Cash value must be at least 1$')
				}
				addError(serverError(`milestones.${index}.data.cash_value`))
			}

			addError(serverError(`milestones.${index}.target`))
			addError(serverError(`milestones.${index}.reward_type`))
			addError(serverError(`milestones.${index}.id`))
			addError(serverError(`milestones.${index}.qty`))
			addError(serverError(`milestones.${index}.data.products`))

			return errors
		},

		hasMilestoneErrors: function (index) {
			return this.getMilestoneErrors(index).length > 0
		},

		getMilestoneImageErrors: function (index) {
			const errors = []
			const seen = new Set()
			const addError = (message) => {
				if (!message) {
					return
				}
				const key = String(message).trim()
				if (!key || seen.has(key)) {
					return
				}
				seen.add(key)
				errors.push(key)
			}
			const serverError = (path) => {
				const value = this.milestone_errors ? this.milestone_errors[path] : null
				if (Array.isArray(value) && value.length) {
					return value[0]
				}
				if (typeof value === 'string') {
					return value
				}
				return null
			}
			const imageError = (path) => {
				return this.image_upload_errors ? this.image_upload_errors[path] : null
			}

			const rewardType = this.reward_type.model[index]
			if (rewardType == 2 && Array.isArray(this.discount_products[index])) {
				this.discount_products[index].forEach((_, discountIndex) => {
					addError(imageError(`milestones.${index}.data.${discountIndex}.image`) ? `Discount #${discountIndex + 1}: ${imageError(`milestones.${index}.data.${discountIndex}.image`)}` : null)
					addError(serverError(`milestones.${index}.data.${discountIndex}.image`) ? `Discount #${discountIndex + 1}: ${serverError(`milestones.${index}.data.${discountIndex}.image`)}` : null)
				})
			}

			if (rewardType == 4 && Array.isArray(this.merchandise_products[index])) {
				this.merchandise_products[index].forEach((_, merchIndex) => {
					addError(imageError(`milestones.${index}.data.products.${merchIndex}.image`) ? `Merchandise #${merchIndex + 1}: ${imageError(`milestones.${index}.data.products.${merchIndex}.image`)}` : null)
					addError(serverError(`milestones.${index}.data.products.${merchIndex}.image`) ? `Merchandise #${merchIndex + 1}: ${serverError(`milestones.${index}.data.products.${merchIndex}.image`)}` : null)
				})
			}

			if (rewardType == 5 && Array.isArray(this.custom_products[index])) {
				this.custom_products[index].forEach((_, customIndex) => {
					addError(imageError(`milestones.${index}.data.${customIndex}.image`) ? `Custom #${customIndex + 1}: ${imageError(`milestones.${index}.data.${customIndex}.image`)}` : null)
					addError(serverError(`milestones.${index}.data.${customIndex}.image`) ? `Custom #${customIndex + 1}: ${serverError(`milestones.${index}.data.${customIndex}.image`)}` : null)
				})
			}

			if (rewardType == 3 || rewardType == 6) {
				addError(imageError(`milestones.${index}.image`))
				addError(serverError(`milestones.${index}.image`))
			}

			return errors
		},

		hasMilestoneImageErrors: function (index) {
			return this.getMilestoneImageErrors(index).length > 0
		},

		getMilestoneInfoMessages: function (index) {
			// Show a single helper line for milestone types that expose at least one image upload.
			const rewardType = this.reward_type.model[index]
			const message = this.milestone_image_help_text

			if (rewardType == 2 && Array.isArray(this.discount_products[index]) && this.discount_products[index].length) {
				return [message]
			}

			if (rewardType == 4 && Array.isArray(this.merchandise_products[index]) && this.merchandise_products[index].length) {
				return [message]
			}

			if (rewardType == 5 && Array.isArray(this.custom_products[index]) && this.custom_products[index].length) {
				return [message]
			}

			if (rewardType == 3 || rewardType == 6) {
				return [message]
			}

			return []
		},

		getFirstValidationErrorElement: function () {
			const root = this.$refs.milestonesRoot
			if (!root) {
				return null
			}

			return root.querySelector('[data-scroll-role="cost-per-views-error"]')
				|| root.querySelector('[data-scroll-role="milestone-summary-error"]')
				|| root.querySelector('.mlst-error-line')
				|| root.querySelector('.milestone-input-error')
				|| root.querySelector('#milestones_group')
				|| root
		},

		scrollToFirstValidationError: function () {
			this.$nextTick(() => {
				const target = this.getFirstValidationErrorElement()
				if (!target) {
					return
				}

				const rect = target.getBoundingClientRect()
				const offset = 120
				const y = rect.top + window.pageYOffset - offset
				window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' })
			})
		},

		validateMilestonesForSubmit: function () {
			if (!this.parent_requirements_met) {
				this.show_milestone_errors = false
				this.action_of_rewarding_error = 'The Action of rewarding field is required.'
				this.allocation_type_error = ''
				return false
			}

			this.show_milestone_errors = true
			// Validate action of rewarding is selected
			if (!this.reward_type_for) {
				this.action_of_rewarding_error = 'The Action of rewarding field is required.'
				return false
			}
			this.action_of_rewarding_error = ''

			// Validate allocation type is selected when visible
			if (!this.showCostPerThousandViews && !this.allocation_type) {
				this.allocation_type_error = 'Please select the type of rewards allocation.'
				return false
			}
			this.allocation_type_error = ''

			// Enforce required milestone fields (images are optional).
				if (this.showCostPerThousandViews) {
					const value = this.cost_per_x_views
					const parsed = parseFloat(value)
					if (value === null || value === undefined || value === '' || Number.isNaN(parsed) || parsed < 0.1) {
						this.cost_per_views_error = 'The cost per 1000 views field must be a minimum of 0.1$.'
						return false
					}
					return this.validateCostPerViewsAgainstMaximum()
				}

			let isValid = true
			const total = parseInt(this.milestones_count || 0, 10)

			for (let index = 0; index < total; index += 1) {
				const rewardType = this.reward_type.model[index]
				this.reward_type_submitted[index] = rewardType
				this.missing_discount_products[index] = false
				this.missing_merchandise_products[index] = false
				this.missing_custom_products[index] = false
				this.missing_targets[index] = false
				this.missing_reward_types[index] = false
				this.invalid_target_sequence[index] = false

				const targetValue = this.reward_target_value.model[index]
				if (targetValue === null || targetValue === undefined || targetValue === '' || targetValue < 1) {
					this.missing_targets[index] = true
					isValid = false
				}
				const prevMaxTargetValue = this.reward_target_value.model
					.slice(0, index)
					.reduce((max, val) => {
						const num = val === null || val === undefined || val === '' ? null : Number(val)
						if (Number.isNaN(num) || num === null) {
							return max
						}
						return max === null || num > max ? num : max
					}, null)
				if (prevMaxTargetValue !== null && targetValue && prevMaxTargetValue >= targetValue) {
					this.invalid_target_sequence[index] = true
					isValid = false
				}

				if (this.pag_campaign && !rewardType) {
					this.missing_reward_types[index] = true
					isValid = false
					continue
				}

				if (this.budget_campaign) {
					this.qty_touched[index] = true
					const qtyValue = this.qty.model[index]
					if (qtyValue === null || qtyValue === undefined || qtyValue === '' || qtyValue < 1 || qtyValue > 999999) {
						isValid = false
					}
					if (this.allocation_type == 1 && this.maximum_reward_per_video !== null && parseFloat(qtyValue) > this.maximum_reward_per_video) {
						isValid = false
					}
					continue
				}

				if (rewardType == 2) {
					this.target_touched[index] = true
					this.ensureDiscountArrays(index)
					if (!this.discount_products[index] || !this.discount_products[index].length) {
						this.missing_discount_products[index] = true
						isValid = false
					} else {
						this.discount_products[index].forEach((_, discountIndex) => {
							this.discount_values_touched[index][discountIndex] = true
							this.discount_qty_touched[index][discountIndex] = true
							const value = this.discount_values[index][discountIndex]
							const qty = this.discount_qty[index][discountIndex]
							if (value === null || value < 1 || value > 100 || qty === null || qty < 1) {
								isValid = false
							}
						})
					}
					continue
				}

				if (rewardType == 4) {
					this.target_touched[index] = true
					this.ensureMerchandiseArrays(index)
					if (!this.merchandise_products[index] || !this.merchandise_products[index].length) {
						this.missing_merchandise_products[index] = true
						isValid = false
					} else {
						this.merchandise_products[index].forEach((_, merchIndex) => {
							this.merchandise_qty_touched[index][merchIndex] = true
							const qty = this.merchandise_qty[index][merchIndex]
							if (qty === null || qty < 1) {
								isValid = false
							}
						})
					}
					continue
				}

				if (rewardType == 5) {
					this.target_touched[index] = true
					this.ensureCustomArrays(index)
					if (!this.custom_products[index] || !this.custom_products[index].length) {
						this.missing_custom_products[index] = true
						isValid = false
					} else {
						this.custom_products[index].forEach((item, customIndex) => {
							this.custom_name_touched[index][customIndex] = true
							this.custom_qty_touched[index][customIndex] = true
							if (!item?.name || item?.qty === null || item?.qty < 1) {
								isValid = false
							}
						})
					}
					continue
				}

				if (rewardType == 3) {
					this.target_touched[index] = true
					this.gift_value_touched[index] = true
					const value = this.gift_discount.model[index]
					if (value === null || value === undefined || value === '' || value < 1) {
						isValid = false
					}
				}

				if (rewardType == 6) {
					this.target_touched[index] = true
					this.cash_value_touched[index] = true
					const value = this.cash_value.model[index]
					if (value === null || value === undefined || value === '' || value < 1) {
						isValid = false
					}
				}

				if (rewardType && rewardType != 2 && rewardType != 4 && rewardType != 5) {
					this.target_touched[index] = true
					if (this.qty.model[index] === null || this.qty.model[index] < 1) {
						isValid = false
					}
				}
			}

			if (this.budget_campaign && this.isCumulativeSumInvalid()) {
				isValid = false
			}
			if (this.budget_campaign && this.isPerMilestoneLastInvalid()) {
				isValid = false
			}

			if (!isValid && this.pag_campaign) {
				for (let index = 0; index < total; index += 1) {
					if (this.hasMilestoneErrors(index) || this.hasMilestoneImageErrors(index)) {
						this.expanded_milestones[index] = true
					}
				}
			}

			return isValid
		},

		getImagePreviewUrl: function (index) {
			// Normalize preview for gift/cash uploads or existing milestone images.
			const image = this.images[index]
			if (!image) {
				return null
			}
			if (Array.isArray(image)) {
				return image[0] || null
			}
			return image.original_url || image
		},

		deleteImage: function (index, element) {
			this.images[index] = []
			document.getElementsByName(element)[0].value = ''
		},

			addCustomProduct: function (index) {
				// Add a custom row with name/qty/image inputs.
				this.ensureCustomArrays(index)
				if (this.hasReachedMilestoneItemLimit(5, index)) {
					return
				}
				this.custom_products[index].push({
					name: '',
				qty: null,
				preview_url: null
			})
			this.missing_custom_products[index] = false
			const customIndex = this.custom_products[index].length - 1
			this.custom_name_touched[index][customIndex] = false
			this.custom_qty_touched[index][customIndex] = false
		},

		deleteCustomProduct: function (index, customIndex) {
			// Remove a custom row.
			if (!this.custom_products[index]) {
				return
			}
			this.custom_products[index].splice(customIndex, 1)
			if (this.custom_name_touched[index]) {
				this.custom_name_touched[index].splice(customIndex, 1)
			}
			if (this.custom_qty_touched[index]) {
				this.custom_qty_touched[index].splice(customIndex, 1)
			}
		},


		// Restore values after a failed submit/draft reload.
		setOldValues: function () {
			if (this.set_values) {
				if (this.set_values.action_of_rewarding) {
					this.reward_type_for = this.set_values.action_of_rewarding
				}

				// Restore the view-count amount (cost_per_x_views) after a
				// validation-fail redirect — otherwise it reset to empty.
				if (this.set_values.cost_per_x_views != null && this.set_values.cost_per_x_views !== '') {
					this.cost_per_x_views = this.set_values.cost_per_x_views
				}


				if (this.set_values.reward_allocation_type) {
					this.allocation_type = this.set_values.reward_allocation_type
				}

				if (this.set_values.milestones_number) {
					this.milestones_count = parseInt(this.set_values.milestones_number)
				}

				if(this.set_values.show_milestones_qty) {
					this.milestones_qty_state = this.set_values.show_milestones_qty
				}

				if (this.set_values.type && (this.set_values.type == '1' || this.set_values.type == 1)) {
					this.budget_campaign = true
					this.pag_campaign = false
				}

				if (this.set_values.type && (this.set_values.type == '2' || this.set_values.type == 2)) {
					this.budget_campaign = false
					this.pag_campaign = true
				}

				if (this.set_values.milestones
					&& parseInt(this.set_values.milestones[0]?.reward_type) !== 7) {
					for (let x = 0; x <= this.set_values.milestones.length; x++) {
						// this.discount_products[x] = []
						if (this.set_values.milestones[x] && this.set_values.milestones[x].reward_type) {
							this.reward_type.model[x] = this.set_values.milestones[x].reward_type
						}

						if (this.set_values.milestones[x] && this.set_values.milestones[x].target) {
							this.reward_target_value.model[x] = this.set_values.milestones[x].target
						}

						if (this.set_values.milestones[x] && this.set_values.milestones[x].qty) {
							this.qty.model[x] = this.set_values.milestones[x].qty
						}

						if (this.set_values.milestones[x] && this.set_values.milestones[x].image) {

							if (!this.images[x]) {
								this.images[x] = []
							}

							this.images[x] = this.set_values.milestones[x].image
						}

						if (this.set_values.milestones[x] && this.set_values.milestones[x].data) {
							this.gift_discount.model[x] = this.set_values.milestones[x].data.gift_card_value
							this.cash_value.model[x] = this.set_values.milestones[x].data.cash_value


							const discountData = this.set_values.milestones[x].data
							if (parseInt(this.set_values.milestones[x].reward_type) === 2) {
								if (Array.isArray(discountData) && discountData.length) {
									this.ensureDiscountArrays(x)
									discountData.forEach((item, idx) => {
										this.discount_products[x].push(item)
										this.discount_values[x][idx] = item.discount_value ?? null
										const qtyValue = item.qty ?? this.set_values.milestones[x].qty ?? null
										this.discount_qty[x][idx] = qtyValue
										this.discount_values_touched[x][idx] = false
										this.discount_qty_touched[x][idx] = false
									})
									this.show_discount_search[x] = false
								} else if (discountData && discountData.discount_product_id) {
									this.ensureDiscountArrays(x)
									this.discount_products[x].push(discountData)
									this.discount_values[x][0] = discountData.discount_value ?? null
									const qtyValue = discountData.qty ?? this.set_values.milestones[x].qty ?? null
									this.discount_qty[x][0] = qtyValue
									this.discount_values_touched[x][0] = false
									this.discount_qty_touched[x][0] = false
									this.show_discount_search[x] = false
								}
							}
						}

						if (this.set_values.milestones[x] && this.set_values.milestones[x].reward_type == 5) {
							const customData = this.set_values.milestones[x].data
							const customMedia = this.set_values.milestones[x].media || []
							if (Array.isArray(customData) && customData.length) {
								this.ensureCustomArrays(x)
								customData.forEach((item, idx) => {
									const imageValue = Array.isArray(item.image) ? (item.image[0] ?? null) : item.image
									const fallbackMedia = customMedia[idx]?.original_url ?? customMedia[idx]?.preview_url ?? null
									this.custom_products[x].push({
										name: item.name ?? '',
										qty: item.qty ?? null,
										image: imageValue || fallbackMedia || null,
										preview_url: null
									})
									this.custom_name_touched[x][idx] = false
									this.custom_qty_touched[x][idx] = false
								})
							}
						}

						if (this.set_values.milestones[x] && this.set_values.milestones[x].data && this.set_values.milestones[x].data.products && this.set_values.milestones[x].data.products.length) {

							if (!this.merchandise_products[x]) {
								this.merchandise_products[x] = []
							}


							this.merchandise_products[x].push(...this.set_values.milestones[x].data.products)
							this.ensureMerchandiseArrays(x)
							this.set_values.milestones[x].data.products.forEach((product, idx) => {
								this.merchandise_qty[x][idx] = product.qty ?? null
								this.merchandise_qty_touched[x][idx] = false
							})
							this.show_merch_search[x] = false
						}
					}
				}
			}
		},


		// Restore values when editing an existing campaign.
		setEditValues: function () {
			if (this.campaign_data) {
				if (this.campaign_data.action_of_rewarding) {
					this.reward_type_for = this.campaign_data.action_of_rewarding
				}

				if (this.campaign_data.reward_allocation_type) {
					this.allocation_type = this.campaign_data.reward_allocation_type
				}

				if (this.campaign_data.type && (this.campaign_data.type == '1' || this.campaign_data.type == 1)) {
					this.budget_campaign = true
					this.pag_campaign = false
				}

				if (this.campaign_data.type && (this.campaign_data.type == '2' || this.campaign_data.type == 2)) {
					this.budget_campaign = false
					this.pag_campaign = true
				}

				if(this.campaign_data.show_milestones_qty) {
					this.milestones_qty_state = this.campaign_data.show_milestones_qty
				}

				if (this.campaign_data.milestones
					&& parseInt(this.campaign_data.milestones[0]?.reward_type) !== 7) {
					this.milestones_count = this.campaign_data.milestones.length

					for (let x = 0; x <= this.campaign_data.milestones.length; x++) {
						// this.discount_products[x] = []

						if (this.campaign_data.milestones[x] && this.campaign_data.milestones[x].reward_type) {
							this.reward_type.model[x] = this.campaign_data.milestones[x].reward_type
						}

						if (this.campaign_data.milestones[x] && this.campaign_data.milestones[x].target) {
							this.reward_target_value.model[x] = this.campaign_data.milestones[x].target
						}

						if (this.campaign_data.milestones[x] && this.campaign_data.milestones[x].qty) {
							this.qty.model[x] = this.campaign_data.milestones[x].qty
						}

						if (this.campaign_data.milestones[x] && this.campaign_data.milestones[x].media) {

							if (!this.images[x]) {
								this.images[x] = []
							}

							this.images[x] = this.campaign_data.milestones[x].media[0]
						}

						if (this.campaign_data.milestones[x] && this.campaign_data.milestones[x].reward_data && this.campaign_data.milestones[x].reward_data) {
							this.gift_discount.model[x] = this.campaign_data.milestones[x].reward_data.gift_card_value
							this.cash_value.model[x] = this.campaign_data.milestones[x].reward_data.cash_value
							// this.discount_products[x] = this.campaign_data.milestones[x].reward_data.discount_product_id
							// discountet product name

							const discountData = this.campaign_data.milestones[x].reward_data
							if (parseInt(this.campaign_data.milestones[x].reward_type) === 2) {
								if (Array.isArray(discountData) && discountData.length) {
									this.ensureDiscountArrays(x)
									discountData.forEach((item, idx) => {
										this.discount_products[x].push(item)
										this.discount_values[x][idx] = item.discount_value ?? null
										const qtyValue = item.qty ?? this.campaign_data.milestones[x].qty ?? null
										this.discount_qty[x][idx] = qtyValue
										this.discount_values_touched[x][idx] = false
										this.discount_qty_touched[x][idx] = false
									})
									this.show_discount_search[x] = false
								} else if (discountData && discountData.discount_product_id) {
									this.ensureDiscountArrays(x)
									this.discount_products[x].push(discountData)
									this.discount_values[x][0] = discountData.discount_value ?? null
									const qtyValue = discountData.qty ?? this.campaign_data.milestones[x].qty ?? null
									this.discount_qty[x][0] = qtyValue
									this.discount_values_touched[x][0] = false
									this.discount_qty_touched[x][0] = false
									this.show_discount_search[x] = false
								}
							}
						}

						if (this.campaign_data.milestones[x] && this.campaign_data.milestones[x].reward_type == 5) {
							const customData = this.campaign_data.milestones[x].reward_data
							const customMedia = this.campaign_data.milestones[x].media || []
							if (Array.isArray(customData) && customData.length) {
								this.ensureCustomArrays(x)
								customData.forEach((item, idx) => {
									const imageValue = Array.isArray(item.image) ? (item.image[0] ?? null) : item.image
									const fallbackMedia = customMedia[idx]?.original_url ?? customMedia[idx]?.preview_url ?? null
									this.custom_products[x].push({
										name: item.name ?? '',
										qty: item.qty ?? null,
										image: imageValue || fallbackMedia || null,
										preview_url: null
									})
									this.custom_name_touched[x][idx] = false
									this.custom_qty_touched[x][idx] = false
								})
							}
						}

						if (this.campaign_data.milestones[x] && this.campaign_data.milestones[x].reward_data && this.campaign_data.milestones[x].reward_data.products && this.campaign_data.milestones[x].reward_data.products.length) {

							if (!this.merchandise_products[x]) {
								this.merchandise_products[x] = []
							}


							this.merchandise_products[x].push(...this.campaign_data.milestones[x].reward_data.products)
							this.ensureMerchandiseArrays(x)
							this.campaign_data.milestones[x].reward_data.products.forEach((product, idx) => {
								this.merchandise_qty[x][idx] = product.qty ?? null
								this.merchandise_qty_touched[x][idx] = false
							})
							this.show_merch_search[x] = false
						}
					}
				}
			}
		}
	},

	mounted() {
		// let type_campaign_changer = document.getElementsByName('type_campaign')
		let elements = document.querySelectorAll('div.type_budget');
		let budget_changer = document.getElementById('to_budget_change')
		let pag_changer = document.getElementById('to_pag_change')
		let end_camp_container = document.getElementById('expire_date_container')

		this.is_mounted = true

			const maxRewardInput = document.getElementById('maximum_reward_per_video')
			if (maxRewardInput) {
				this.maximum_reward_per_video = parseFloat(maxRewardInput.value) || null
				maxRewardInput.addEventListener('input', () => {
					this.maximum_reward_per_video = parseFloat(maxRewardInput.value) || null
					this.validateCostPerViewsAgainstMaximum()
				})
			}

		if (this.set_values) {
		}

		if ((this.campaign_data && this.set_values) || this.set_values) {
			this.setOldValues()
		} else {
			this.setEditValues()
		}

		this.restore_used = this.set_values ? 'old' : 'edit'
		this.original_action_of_rewarding = parseInt(this.reward_type_for)

		const stepOneForm = document.getElementById('step-1-form')
		if (stepOneForm?.dataset.campaignTypeReady) {
			this.parent_requirements_met = stepOneForm.dataset.campaignTypeReady === 'true'
		}
		this.flow_update_handler = (event) => {
			this.parent_requirements_met = Boolean(event.detail?.campaignTypeReady)
		}
		window.addEventListener('campaign-step-flow-updated', this.flow_update_handler)

		if (pag_changer && elements) {
			pag_changer.addEventListener('change', () => {

				if (end_camp_container.classList.contains('d-none')) {
					end_camp_container.classList.remove('d-none')
				}

				this.pag_campaign = true
				this.budget_campaign = false

				for (let y = 0; y < elements.length; y++) {
					elements[y].classList.add('d-none')
				}
			})
		}

		if (budget_changer) {
			budget_changer.addEventListener('change', () => {
				if (end_camp_container.classList.contains('d-none')) {
					end_camp_container.classList.remove('d-none')
				}

				this.pag_campaign = false
				this.budget_campaign = true
				// this.reward_type.model = []
				// this.merchandise_products = []

				for (let y = 0; y < elements.length; y++) {
					if (elements[y].classList.contains('d-none')) {
						elements[y].classList.remove('d-none')
					}
				}
			})
		}

		if (this.budget_campaign) {
			if (end_camp_container.classList.contains('d-none')) {
				end_camp_container.classList.remove('d-none')
			}
			for (let y = 0; y < elements.length; y++) {
				if (elements[y].classList.contains('d-none')) {
					elements[y].classList.remove('d-none')
				}
			}
		}

		if (this.pag_campaign) {
			if (end_camp_container.classList.contains('d-none')) {
				end_camp_container.classList.remove('d-none')
			}
			for (let y = 0; y < elements.length; y++) {
				elements[y].classList.add('d-none')
			}
		}

		// Live selection from step 1 checkboxes (keeps popover list in sync).
		if (window.selectedSocials && Array.isArray(window.selectedSocials)) {
			this.selected_socials_live = window.selectedSocials
		}
		window.addEventListener('selected-socials-updated', (event) => {
			this.selected_socials_live = Array.isArray(event.detail) ? event.detail : []
		})
		// Capture outside clicks to close the popover.
		this.view_count_outside_handler = this.handleViewCountOutsideClick.bind(this)
		document.addEventListener('pointerdown', this.view_count_outside_handler, true)
		window.milestonesComponent = this

	},


	unmounted() {
		this.is_mounted = false
		if (this.flow_update_handler) {
			window.removeEventListener('campaign-step-flow-updated', this.flow_update_handler)
		}
		if (this.view_count_outside_handler) {
			document.removeEventListener('pointerdown', this.view_count_outside_handler, true)
		}
		if (window.milestonesComponent === this) {
			delete window.milestonesComponent
		}
	},

	created() {
    },
}
</script>


<style scoped lang="scss" src="../../sass/_milestones-configuration.scss"></style>
